// Global Variable
var intlTelInstance = {};

function vwThemeStrings() {
    return (window.theme && window.theme.strings) || {};
}
function vorwerkStorepointWidgetStrings() {
    return window.theme?.strings?.storepointWidget || {};
}

// start: BookX booking event
(function bookeasySuccessPopup() {
    var DEFAULT_POPUP_TEXT = '<p>Booking submitted <strong>successfully!</strong></p>';
    var popup = null;
    var previouslyFocused = null;
    var submitTimer = null;
    var submitLockUntil = 0;
    var popupConfig = null;

    function getPopup() {
        if (!popup) popup = document.querySelector('[data-bookeasy-success-popup]');
        return popup;
    }

    function getPopupConfig() {
        if (popupConfig) return popupConfig;
        var node = document.querySelector('[data-bookeasy-success-config]');
        if (!node) {
            popupConfig = { sets: [] };
            return popupConfig;
        }
        try {
            popupConfig = JSON.parse(node.textContent || '{"sets":[]}');
        } catch (error) {
            popupConfig = { sets: [] };
        }
        return popupConfig;
    }

    function getCurrentProductId() {
        var bookeasyBtn = document.querySelector('.bookeasy-btn[data-product-id]');
        if (bookeasyBtn && bookeasyBtn.getAttribute('data-product-id')) {
            return String(bookeasyBtn.getAttribute('data-product-id'));
        }

        var bookeasyForm = document.querySelector('form[action*="/cart/add"][bookeasy-form-id]');
        if (bookeasyForm && bookeasyForm.getAttribute('bookeasy-form-id')) {
            return String(bookeasyForm.getAttribute('bookeasy-form-id'));
        }

        var buyButtons = document.querySelector('block-buy-buttons[data-product-id]');
        if (buyButtons && buyButtons.getAttribute('data-product-id')) {
            return String(buyButtons.getAttribute('data-product-id'));
        }

        if (window.meta && window.meta.product && window.meta.product.id != null) {
            return String(window.meta.product.id);
        }

        if (
            window.ShopifyAnalytics &&
            window.ShopifyAnalytics.meta &&
            window.ShopifyAnalytics.meta.product &&
            window.ShopifyAnalytics.meta.product.id != null
        ) {
            return String(window.ShopifyAnalytics.meta.product.id);
        }

        return '';
    }

    function findMatchingPopupSet(productId) {
        var config = getPopupConfig();
        var sets = (config && config.sets) || [];
        if (!productId || !sets.length) return null;

        for (var i = 0; i < sets.length; i++) {
            var set = sets[i] || {};
            var ids = set.productIds || [];
            for (var j = 0; j < ids.length; j++) {
                if (String(ids[j]) === productId) return set;
            }
        }

        return null;
    }

    function lockScroll(lock) {
        document.documentElement.classList.toggle('bookeasy-success-popup-open', lock);
        document.body.classList.toggle('bookeasy-success-popup-open', lock);
    }

    function redirectAfterClose(el) {
        var url = el && el.getAttribute('data-bookeasy-success-redirect');
        if (!url) return;
        window.location.assign(url);
    }

    function closeBookeasySuccessPopup() {
        var el = getPopup();
        if (!el || el.hidden) return;
        el.hidden = true;
        lockScroll(false);
        if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
        previouslyFocused = null;
        redirectAfterClose(el);
    }

    function applyPopupSet(set) {
        var el = getPopup();
        if (!el || !set) return;

        var title = el.querySelector('#bookeasy-success-popup-title');
        if (title) title.innerHTML = set.text || DEFAULT_POPUP_TEXT;

        if (set.redirect) {
            el.setAttribute('data-bookeasy-success-redirect', set.redirect);
        } else {
            el.removeAttribute('data-bookeasy-success-redirect');
        }
    }

    function openBookeasySuccessPopup() {
        var el = getPopup();
        if (!el) return;
        previouslyFocused = document.activeElement;
        el.hidden = false;
        lockScroll(true);
        var closeBtn = el.querySelector('.bookeasy-success-popup__close-btn');
        if (closeBtn) closeBtn.focus();
    }

    function showBookeasySuccessPopup() {
        var matchedSet = findMatchingPopupSet(getCurrentProductId());
        if (!matchedSet || !matchedSet.showPopup) return;
        applyPopupSet(matchedSet);
        openBookeasySuccessPopup();
    }

    function bindPopup() {
        var el = getPopup();
        if (!el || el.__bookeasyBound) return;
        el.__bookeasyBound = true;
        el.addEventListener('click', function (event) {
            if (event.target.closest('[data-bookeasy-success-close]')) {
                closeBookeasySuccessPopup();
            }
        });
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && el && !el.hidden) {
                closeBookeasySuccessPopup();
            }
        });
    }

    // BookX non-immediate mode stamps booking fields into the product form, then expects
    // an ATC click. Demo-sessions keeps ATC hidden, so submit it on the theme side.
    function formHasBookeasyBooking(form) {
        if (!form) return false;
        return !!(
            form.querySelector('#bookeasy-product-properties') ||
            form.querySelector('[id="bookeasy-booking-id"]') ||
            form.querySelector('input[name="properties[_bookeasy-booking-id]"]') ||
            form.querySelector('input[name="properties[Date]"]')
        );
    }

    function findBookeasyProductForm() {
        var forms = document.querySelectorAll('form[action*="/cart/add"]');
        for (var i = 0; i < forms.length; i++) {
            if (formHasBookeasyBooking(forms[i])) return forms[i];
        }
        return null;
    }

    function submitHiddenBookeasyAtc() {
        if (Date.now() < submitLockUntil) return;
        var form = findBookeasyProductForm();
        if (!form) return;
        var addBtn = form.querySelector('[name="add"]');
        if (!addBtn || addBtn.disabled) return;
        submitLockUntil = Date.now() + 4000;
        addBtn.click();
    }

    function scheduleHiddenBookeasyAtcSubmit() {
        if (submitTimer) clearTimeout(submitTimer);
        // Wait until BookX finishes injecting booking properties into the form.
        submitTimer = setTimeout(submitHiddenBookeasyAtc, 100);
    }

    function wrapFbq(fbq) {
        if (typeof fbq !== 'function' || fbq.__bookeasyHooked) return fbq;

        function hooked() {
            var command = arguments[0];
            var eventName = arguments[1];
            if (command === 'track' || command === 'trackCustom') {
                if (eventName === 'bookeasy_widget_closed') {
                    scheduleHiddenBookeasyAtcSubmit();
                }
                if (eventName === 'bookeasy_product_added_to_cart') {
                    showBookeasySuccessPopup();
                }
            }
            return fbq.apply(this, arguments);
        }

        hooked.__bookeasyHooked = true;
        Object.keys(fbq).forEach(function (key) {
            hooked[key] = fbq[key];
        });
        return hooked;
    }

    var current = window.fbq;
    try {
        Object.defineProperty(window, 'fbq', {
            configurable: true,
            get: function () {
                return current;
            },
            set: function (value) {
                current = wrapFbq(value);
            },
        });
        if (current) current = wrapFbq(current);
    } catch (error) {
        if (current) window.fbq = wrapFbq(current);
    }

    function init() {
        bindPopup();
        document.addEventListener('closeBookeasyWidget', scheduleHiddenBookeasyAtcSubmit, true);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.showBookeasySuccessPopup = showBookeasySuccessPopup;
    window.closeBookeasySuccessPopup = closeBookeasySuccessPopup;
})();
// end: BookX booking event

$(function() {
    const runReferralCheck = !document.referrer.includes('choose-from-your-nearest-advisors');
    const hasRefParam = new URLSearchParams(window.location.search).has('ref');

    if (runReferralCheck && hasRefParam) {
        checkReferral();
    } else {
        // validateExistingAdvisor();
        if (runReferralCheck) {
            checkReferral();
        }
    }
    onloadTm4u();
    tablePaginate();
    toggleBodyScroll();
    enableAccountUpdateWhenFoundChanges();
    initMySwiper();
    initTextColumnsFlickity();
    setTimeout(() => {
        triggerMapPopup();
        bindFunction();
    }, 4500);
    onloadInitFunctions();
    onloadGetAnchorLink();
    setTimeout(() => {
        eventListnerTriggerPopup();
    }, 4500);
    if (document.referrer.includes('register')) {
        onLoadLoader();
    }
    removeProfileUpdateError();
    toggleMegaMenuOverlay();
    // hoverATCbutton();

    initStickyScrollIcon();
    initCollectionFilterCountPreservation();
})

const getCollectionFilterCountStorageKey = () => `collection-filter-counts:${window.location.pathname}`;

const readCollectionFilterCountCache = () => {
    try {
        return JSON.parse(sessionStorage.getItem(getCollectionFilterCountStorageKey()) || '{}');
    } catch (error) {
        return {};
    }
};

const writeCollectionFilterCountCache = (counts) => {
    try {
        sessionStorage.setItem(getCollectionFilterCountStorageKey(), JSON.stringify(counts));
    } catch (error) {
        // Ignore storage failures and keep default server-rendered counts.
    }
};

const getCollectionFilterCountKey = (input) => `${input.name}::${input.value}`;

const parseCollectionFilterCount = (countText) => {
    const parsed = parseInt(String(countText).replace(/[^\d]/g, ''), 10);
    return Number.isFinite(parsed) ? parsed : null;
};

const collectCollectionFilterCounts = (root = document) => {
    const counts = {};

    root.querySelectorAll('.filter-form .tag__input[name][value]').forEach((input) => {
        const label = input.closest('label');
        const countEl = label?.querySelector('[data-filter-count]');

        if (!countEl) {
            return;
        }

        const count = parseCollectionFilterCount(countEl.textContent);
        if (count === null) {
            return;
        }

        counts[getCollectionFilterCountKey(input)] = count;
    });

    return counts;
};

const mergeCollectionFilterCounts = (incomingCounts) => {
    const cachedCounts = readCollectionFilterCountCache();
    let changed = false;

    Object.entries(incomingCounts).forEach(([key, count]) => {
        if (!Number.isFinite(count)) {
            return;
        }

        if (cachedCounts[key] == null || count > cachedCounts[key]) {
            cachedCounts[key] = count;
            changed = true;
        }
    });

    if (changed) {
        writeCollectionFilterCountCache(cachedCounts);
    }

    return cachedCounts;
};

const applyCollectionFilterCounts = (counts, root = document) => {
    root.querySelectorAll('.filter-form .tag__input[name][value]').forEach((input) => {
        const label = input.closest('label');
        const countEl = label?.querySelector('[data-filter-count]');

        if (!countEl) {
            return;
        }

        const count = counts[getCollectionFilterCountKey(input)];
        if (!Number.isFinite(count)) {
            return;
        }

        countEl.textContent = `(${count})`;
    });
};

const initCollectionFilterCountPreservation = async () => {
    const filterForm = document.querySelector('.filter-form');
    if (!filterForm) {
        return;
    }

    let cachedCounts = mergeCollectionFilterCounts(collectCollectionFilterCounts(document));
    applyCollectionFilterCounts(cachedCounts, document);

    if (Object.keys(cachedCounts).length > 0) {
        return;
    }

    try {
        const response = await fetch(window.location.pathname, { credentials: 'same-origin' });
        if (!response.ok) {
            return;
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        cachedCounts = mergeCollectionFilterCounts(collectCollectionFilterCounts(doc));
        applyCollectionFilterCounts(cachedCounts, document);
    } catch (error) {
        // Ignore fetch failures and keep default server-rendered counts.
    }
};

document.addEventListener('collection:reloaded', () => {
    initCollectionFilterCountPreservation();
});

// Sticky Scroll to Top Icon functionality
function initStickyScrollIcon() {
    const stickyScrollSection = $('.jsc-sticky-scroll-section');
    
    if (!stickyScrollSection.length) {
        return;
    }
    const scrollThreshold = 300; 
    function toggleStickyIcon() {
        if (window.scrollY > scrollThreshold) {
            stickyScrollSection.addClass('show');
        } else {
            stickyScrollSection.removeClass('show');
        }
    }
        toggleStickyIcon();
        $(window).on('scroll', function() {
        toggleStickyIcon();
    });
    
    stickyScrollSection.on('click', function(e) {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
    stickyScrollSection.on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    });
}

const getGenericAlertElements = () => {
    const popup = $('#jsc-generic-alert');
    if (!popup.length) {
        return null;
    }

    return {
        popup,
        overlay: popup.find('.jsc-mixing-popup-overlay'),
        closeButton: popup.find('.jsc-mixing-popup-close'),
        confirmButton: popup.find('#jsc-generic-alert-confirm'),
        messageContainer: popup.find('#jsc-generic-alert-message')
    };
};

const navigateFromGenericAlert = (url, openInNewTab) => {
    if (!url) {
        return;
    }
    if (openInNewTab) {
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    window.location.assign(url);
};

const showGenericAlert = (message, options = {}) => {
    const elements = getGenericAlertElements();
    const fallbackMessage = message == null ? '' : message;
    if (!elements) {
        window.alert(String(fallbackMessage));
        if (options.redirectUrl) {
            window.setTimeout(() => {
                navigateFromGenericAlert(options.redirectUrl, options.openInNewTab);
            }, options.redirectDelay || 3000);
        }
        return;
    }

    const {
        confirmLabel = 'OK',
        onConfirm,
        redirectUrl,
        redirectDelay = 3000,
        hideConfirmButton = false,
        centerMessage = false,
        loadingGifUrl = '',
        closeIconUrl = '',
        openInNewTab = false
    } = options;
    const buttonsWrapper = elements.confirmButton.closest('.jsc-mixing-popup-buttons');
    const shouldHideButton = hideConfirmButton || Boolean(redirectUrl);
    let redirectTimer = null;

    const normalizedMessage = Array.isArray(fallbackMessage)
        ? fallbackMessage.join('<br>')
        : String(fallbackMessage).replace(/\n/g, '<br>');

    if (redirectUrl && loadingGifUrl) {
        elements.messageContainer.html(
            `<div class="jsc-leaving-warning-content">` +
                `<p class="jsc-leaving-warning-text">${normalizedMessage}</p>` +
                `<img class="jsc-leaving-loading-gif" src="${loadingGifUrl}" alt="" width="40" height="40" aria-hidden="true">` +
            `</div>`
        );
    } else if (redirectUrl) {
        elements.messageContainer.html(`<p>${normalizedMessage}</p>`);
    } else {
        elements.messageContainer.html(normalizedMessage);
    }
    elements.messageContainer.toggleClass('text-center', centerMessage || Boolean(redirectUrl));
    elements.confirmButton.text(confirmLabel);

    if (shouldHideButton) {
        buttonsWrapper.hide();
    } else {
        buttonsWrapper.show();
    }

    if (redirectUrl) {
        elements.popup.addClass('jsc-mixing-popup--leaving-warning');

        if (closeIconUrl) {
            elements.closeButton.html(
                `<img src="${closeIconUrl}" alt="" width="18" height="18" class="jsc-leaving-close-icon">`
            );
        }
    }

    const closePopup = () => {
        elements.popup.css('display', 'none');
        elements.popup.removeClass('jsc-mixing-popup--leaving-warning');
        elements.closeButton.html('&times;');
        $('body').css('overflow', '');
        $('body').removeClass('mixing-popup-open');
        elements.confirmButton.off('click', handleConfirm);
        elements.closeButton.off('click', handleClose);
        elements.overlay.off('click', handleClose);
        if (redirectTimer) {
            clearTimeout(redirectTimer);
            redirectTimer = null;
        }
        buttonsWrapper.show();
        elements.messageContainer.removeClass('text-center');
    };

    const handleClose = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        closePopup();
    };

    const handleConfirm = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (typeof onConfirm === 'function') {
            onConfirm();
        }
        closePopup();
    };

    elements.closeButton.off('click').on('click', handleClose);
    elements.overlay.off('click').on('click', handleClose);
    elements.confirmButton.off('click').on('click', handleConfirm);

    elements.popup.css('display', 'flex');
    $('body').css('overflow', 'hidden');
    $('body').addClass('mixing-popup-open');

    if (redirectUrl) {
        redirectTimer = window.setTimeout(() => {
            navigateFromGenericAlert(redirectUrl, openInNewTab);
            closePopup();
        }, redirectDelay);
    }

    requestAnimationFrame(() => {
        if (shouldHideButton) {
            elements.closeButton.trigger('focus');
        } else {
            elements.confirmButton.trigger('focus');
        }
    });
};

window.showGenericAlert = showGenericAlert;

const isCustomerLoggedIn = () => {
    const customerInfo = window.theme && window.theme.customerInfo;
    if (!customerInfo) {
        return false;
    }
    const name = (customerInfo.name || '').trim();
    return name !== '' && name.toLowerCase() !== 'guest';
};

const showLoginRequiredPrompt = () => {
    const message = 'To complete your purchase, please log in or set up an account first.';
    const baseLoginUrl = (window.theme && window.theme.routes && window.theme.routes.accountLogin) || '/account/login';
    const connector = baseLoginUrl.includes('?') ? '&' : '?';
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    const loginUrl = `${baseLoginUrl}${connector}return_url=${returnUrl}`;

    showGenericAlert(message, {
        confirmLabel: 'OK',
        onConfirm: () => {
            document.dispatchEvent(new CustomEvent('login-consent:required', {
                detail: { loginUrl: loginUrl }
            }));
        }
    });
};

initMySwiper = () => {
    if (typeof Swiper === 'undefined') {
        return;
    }
    // console.log('init mySwiper');
    $('.swiper.mySwiper').each(function(index, element) {
        var _this = $(element);
        var autoplay = _this.data('autoplay');
        var autoplaySpeed = _this.data('autoplay-speed');

        var swiper_option = {
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            slidesPerView: 'auto',
            spaceBetween: 12,
            centeredSlides: true,
            loop: true,
            initialSlide : 0
        }

        if (autoplay && autoplaySpeed != '') {
            swiper_option['autoplay'] = {
                delay: autoplaySpeed,
                disableOnInteraction: false
            }
        }
        var swiper = new Swiper(this, swiper_option);
    });
}

const onloadInitFunctions = () => {
    advisorRadioButtonHandling();
    getAdvisorLocalStorage();
    loadAdvisorName();
    // initAdvisorSelector();
};

loadAdvisorName = () =>{
    if ($('#jsc-cart-advisor-name').length) {
        var advisor_name = localStorage.getItem('Advisor Name');
        $('#jsc-cart-advisor-name').text(advisor_name);
        $('#jsc-cart-advisor-name-input').val(advisor_name);
    }
}

// Scripts for Advisor feature starts here
/**
 * HTML template for the advisor selection input field.
 * @type {string}
 */
const search_advisor_field = `
    <div class="jsc-advisor m-t-15 relative">
        <p class="m-b-5">${(vwThemeStrings().demo && vwThemeStrings().demo.pleaseEnterDemoCode) || ''} <span style="color: red;">*</span></p>
        <input id="demo-code-input" type="text" value="" name="attributes[Demo Code]" class="advisor-text" style="width: 25ch;" placeholder="${(vwThemeStrings().demo && vwThemeStrings().demo.enterDemoCodePlaceholder) || ''}">
    </div>
`;
const search_advisor_field_no_demo = `
    <div class="jsc-advisor m-t-15">
        <p class="m-b-5">${(vwThemeStrings().demo && vwThemeStrings().demo.choosePreferredAdvisor) || ''} <span style="color: red;">*</span></p>
        <p class="m-b-10" style="font-size: 0.9em;">
            <a href="/pages/store-locator" target="_blank" style="text-decoration: underline;">${(vwThemeStrings().demo && vwThemeStrings().demo.findAdvisorNearYou) || ''}</a>
        </p>
        <input id="search-advisor" type="text" value="" aria-label="${(vwThemeStrings().demo && vwThemeStrings().demo.choosePreferredAdvisor) || ''}" name="attributes[Advisor ID]" class="advisor-text full-width full-max-width" placeholder="${(vwThemeStrings().demo && vwThemeStrings().demo.enterAdvisorNameOrId) || ''}">
        <div id="advisor-search-results" class="advisor-search-results"></div>
    </div>
`;

/**
 * Handles the changes to the demo radio buttons and updates local storage.
 */
const PREVIOUS_DEMO_ATTR = 'Previous Demo Experience?';

const getPreviousDemoAnswer = () => {
    const radioVal = $('.demo-radio:checked').val();
    if (radioVal === 'Yes' || radioVal === 'No') return radioVal;

    const stored = localStorage.getItem(PREVIOUS_DEMO_ATTR);
    if (stored === 'Yes' || stored === 'No') return stored;

    return '-';
};

const advisorRadioButtonHandling = () => {
    // Document delegation keeps this bound when the cart re-renders.
    $(document).on('change', '.demo-radio', function() {
        const selectedValue = $(this).val();
        localStorage.setItem(PREVIOUS_DEMO_ATTR, selectedValue);

        $('#jsc-advisor-error-msg').hide();
        handleAdvisorDisplay(selectedValue);
    });
};

/**
 * Saves the demo answer on the cart. The advisor choice is independent of this
 * answer, so whichever advisor is selected stays on the cart either way.
 * @param {string} selectedValue - The value selected from the demo radio buttons.
 */
const handleAdvisorDisplay = (selectedValue) => {
    $('.jsc-external-demo-code').remove();

    syncAdvisorSelectDisplay();
    handleAdvisorSelector(selectedValue);
};

const handleAdvisorSelector = (selectedValue) => {
    const advisorID = localStorage.getItem('Advisor ID') || '';
    const advisorName = localStorage.getItem('Advisor Name') || '';
    const advisorCity = localStorage.getItem('Advisor City') || '';

    return CartJS.setAttributes({
        [PREVIOUS_DEMO_ATTR]: selectedValue === 'Yes' || selectedValue === 'No' ? selectedValue : '-',
        "Advisor ID": `${advisorID ? advisorID : '-'}`,
        "advisor_id": advisorID && advisorID !== '-' ? `${advisorID}` : '',
        "Advisor Name": `${advisorName ? advisorName : '-'}`,
        "Advisor City": `${advisorCity ? advisorCity : '-'}`,
        "Would you like to select a preferred advisor?": "-"
    });
}

    // $(document).on('cart.requestComplete', function(event, cart) {
    //     console.log('cart request complete');
    // })

const hasReferralAdvisor = () => {
    const refId = localStorage.getItem('Referral ID');
    return !!(refId && refId !== '-' && refId !== null && refId !== '');
};

const hasSelectedAdvisor = () => {
    const advisorId = localStorage.getItem('Advisor ID');
    return !!(advisorId && advisorId !== '-' && advisorId !== null && advisorId !== '');
};

/**
 * Shows or hides the cart warning when its display rule depends on the advisor.
 * Always leaves a rule of "always" as the page rendered it.
 */
const syncCartWarningBanner = () => {
    const banner = document.getElementById('CartWarningBanner');
    if (!banner) return;

    const rule = banner.dataset.displayRule;
    if (!rule || rule === 'always') return;

    const advisorSelected = hasSelectedAdvisor();
    const show = rule === 'advisor_selected' ? advisorSelected : !advisorSelected;
    banner.classList.toggle('d-none', !show);
};

/**
 * Shows the selected-advisor row once an advisor is chosen, and the link to
 * choose one until then. Both are independent of the demo answer.
 */
const syncAdvisorSelectDisplay = () => {
    syncCartWarningBanner();

    const $advisorSelect = $('.jsc-advisor-select');
    const $advisorChoose = $('.jsc-advisor-choose');
    if (!$advisorSelect.length && !$advisorChoose.length) return;

    const advisorSelected = hasSelectedAdvisor();

    $advisorSelect.toggleClass('d-none', !advisorSelected);
    $advisorChoose.toggleClass('d-none', advisorSelected);
};

/**
 * Resolves the advisor kept on the order from the saved answers.
 * @returns {Object} The demo answer and the advisor to attribute the order to.
 */
const getCheckoutAdvisor = () => {
    const demoAnswer = getPreviousDemoAnswer();
    const attachAdvisor = hasSelectedAdvisor();
    const advisorImage = localStorage.getItem('Advisor Profile Picture');

    return {
        demoAnswer,
        id: attachAdvisor ? (localStorage.getItem('Advisor ID') || '-') : '-',
        name: attachAdvisor ? (localStorage.getItem('Advisor Name') || '-') : '-',
        city: attachAdvisor ? (localStorage.getItem('Advisor City') || '-') : '-',
        image: attachAdvisor && isValidValue(advisorImage) ? advisorImage : ''
    };
};

/**
 * Builds the advisor answers written onto advisor product lines at checkout.
 * @param {Object} advisor - Result of `getCheckoutAdvisor`.
 * @returns {Object}
 */
const getAdvisorLineItemProperties = (advisor) => {
    return {
        '_Previous Demo Experience?': advisor.demoAnswer,
        '_Advisor ID': advisor.id,
        '_Advisor Name': advisor.name,
        '_Advisor City': advisor.city,
        '_Advisor Profile Picture': advisor.image
    };
};

// start: add advisor info at line item properties
addAdvisorInfoAtLineItemProperties = async () => {
    try {
        // fetch cart items
        const cart = await fetch('/cart.js').then(res => res.json());

        // Filter items that are advisor products
        const advisorItems = cart.items.filter(item => item.properties && item.properties._is_advisor_product === "true");
        // console.log('advisorItems: ', advisorItems);

        // If no advisor items, return early
        if (advisorItems.length === 0) {
            return true;
        }

        const advisor = getCheckoutAdvisor();
        const advisorProperties = getAdvisorLineItemProperties(advisor);

        const updatePromises = advisorItems.map(item => {
            const updatedProps = {
                ...item.properties,
                ...advisorProperties
            };

            // Turkey no longer asks the complimentary advisor question
            delete updatedProps['Would you like to select a preferred advisor?'];
            delete updatedProps['_Would you like to select a preferred advisor?'];

            return CartJS.updateItemById(item.key, item.quantity, updatedProps);
        });
        // console.log('updatePromises: ', updatePromises);

        // Wait for all updates to complete
        await Promise.all(updatePromises);
        return true;
    } catch (error) {
        // console.error("Error updating line item properties:", error);
        return false;
    }
}
// end: add advisor info at line item properties

/**
 * Helper function to validate if a value is not blank, undefined, null, or "-"
 * @param {*} val - The value to validate
 * @returns {boolean} - True if value is valid, false otherwise
 */
const isValidValue = (val) => {
    return val && val !== '' && val !== '-' && val !== 'undefined' && val !== 'null' && val.trim() !== '';
};

/**
 * Helper function to show advisor checkout error message
 * @param {string} message - The error message to display
 */
const showAdvisorCheckoutError = (message) => {
    const el = document.getElementById('jsc-advisor-error-msg');
    if (el) {
        el.textContent = message;
        el.style.display = 'block';
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
        alert(message);
    }
};

// Milliseconds to wait for the cart attribute update before sending the
// shopper to checkout anyway, so a request that never completes cannot leave
// the loading overlay covering the page.
const CHECKOUT_REQUEST_TIMEOUT = 8000;
let checkoutRequestTimer = null;
let checkoutRequestCompleteHandler = null;

const clearCheckoutRequest = () => {
    clearTimeout(checkoutRequestTimer);
    checkoutRequestTimer = null;

    if (checkoutRequestCompleteHandler) {
        $(document).off('cart.requestComplete', checkoutRequestCompleteHandler);
        checkoutRequestCompleteHandler = null;
    }
};

/**
 * Binds a one-shot cart.requestComplete handler and a timeout fallback so a
 * request that never completes cannot leave the loading overlay covering the page.
 */
const bindCheckoutRequestComplete = (handler) => {
    clearCheckoutRequest();
    checkoutRequestCompleteHandler = handler;
    $(document).one('cart.requestComplete', handler);
    checkoutRequestTimer = setTimeout(handler, CHECKOUT_REQUEST_TIMEOUT);
};

/**
 * Sends the shopper to Shopify checkout once the cart attributes are saved.
 */
const submitShopifyCheckout = () => {
    clearCheckoutRequest();
    $('.jsc-loader-overlay').hide();
    const checkoutPath = (window.theme && window.theme.urls && typeof window.theme.urls.toStoreUrl === 'function')
        ? window.theme.urls.toStoreUrl('checkout')
        : '/checkout';
    location.href = checkoutPath;
};

/**
 * Clears the loading state left behind on the cart when the shopper leaves for
 * checkout. Browsers keep the page in their back-forward cache, so on a back
 * navigation the overlay and button spinner are restored as they were and
 * swallow every click until the shopper reloads.
 */
const resetCartLoadingState = () => {
    clearCheckoutRequest();
    $('.jsc-loader-overlay').hide();
    $('.cart__checkout, .btn-split-payment').removeClass('btn--loading');
    $('body').removeClass('disabled-event');

    // The cart may have changed while the shopper was in checkout.
    document.dispatchEvent(new CustomEvent('cart:build'));
};

window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
        resetCartLoadingState();
    }
});

// The bundle-components Cart Transform replaces the bundle line at checkout.
// It only copies attributes stored inside `_bundle_components.main`, so the
// bundle line's properties have to be written there before checkout. Turkey
// keeps one catalog `price` per component and does not send `prices`,
// `_Division`, `_Sales unit`, or the preferred-advisor question.
const BUNDLE_COMPONENTS_PROPERTY = '_bundle_components';
const OMITTED_BUNDLE_ATTRIBUTE_KEYS = new Set([
    BUNDLE_COMPONENTS_PROPERTY,
    '_Division',
    '_Sales unit',
    'Would you like to select a preferred advisor?',
    '_Would you like to select a preferred advisor?'
]);

/**
 * @param {string} raw - The `_bundle_components` JSON.
 * @returns {Object|null}
 */
const parseBundleComponentsJson = (raw) => {
    if (!raw) return null;

    try {
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || !Array.isArray(parsed.components)) return null;
        return parsed;
    } catch (error) {
        return null;
    }
};

/**
 * Bundle JSON rendered on the cart line, used when the line was added without
 * the product form property.
 * @returns {Map<string, Object>}
 */
const getBundleComponentsByProduct = () => {
    const bundles = new Map();

    for (const line of document.querySelectorAll('.cart__item[data-bundle-components]')) {
        const bundle = parseBundleComponentsJson(line.dataset.bundleComponents);
        if (bundle) bundles.set(String(line.dataset.productId), bundle);
    }

    return bundles;
};

/**
 * Copies the bundle line's properties into `main`, and keeps each component's
 * catalog price. Division, sales unit, and the preferred-advisor question are
 * left out of both `main` and the line.
 * @param {Object} bundle
 * @param {Object} lineProperties
 * @returns {string}
 */
const buildBundleComponentsProperty = (bundle, lineProperties) => {
    const main = {};

    for (const [key, value] of Object.entries(lineProperties || {})) {
        if (OMITTED_BUNDLE_ATTRIBUTE_KEYS.has(key)) continue;
        main[key] = value;
    }

    const components = bundle.components.map((component) => {
        const attributes = {};

        for (const [key, value] of Object.entries(component.attributes || {})) {
            if (OMITTED_BUNDLE_ATTRIBUTE_KEYS.has(key)) continue;
            attributes[key] = value;
        }

        return {
            id: component.id,
            price: component.price,
            is_main_product: component.is_main_product,
            attributes
        };
    });

    return JSON.stringify({ main, components });
};

/**
 * Rewrites each bundle line so it carries the advisor properties and a
 * `_bundle_components` value whose `main` matches those properties.
 * @param {boolean} isAdvisorProduct - Whether checkout is collecting advisor answers.
 * @returns {Promise<boolean>}
 */
const applyBundleComponentProperties = async (isAdvisorProduct) => {
    try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const cart = await fetch(`${root}cart.js`).then((res) => res.json());
        const bundlesByProduct = getBundleComponentsByProduct();
        const collectAdvisor = isAdvisorProduct === true || isAdvisorProduct === 'true';
        const advisorProperties = collectAdvisor ? getAdvisorLineItemProperties(getCheckoutAdvisor()) : null;
        const updates = [];

        for (const item of cart.items || []) {
            const properties = { ...(item.properties || {}) };
            const bundle = bundlesByProduct.get(String(item.product_id))
                || parseBundleComponentsJson(properties[BUNDLE_COMPONENTS_PROPERTY]);

            if (!bundle) continue;

            if (advisorProperties) Object.assign(properties, advisorProperties);

            let hadOmittedAttribute = false;
            for (const key of OMITTED_BUNDLE_ATTRIBUTE_KEYS) {
                if (key === BUNDLE_COMPONENTS_PROPERTY) continue;
                if (!Object.prototype.hasOwnProperty.call(properties, key)) continue;
                hadOmittedAttribute = true;
                delete properties[key];
            }

            const nextBundleComponents = buildBundleComponentsProperty(bundle, properties);
            if (!hadOmittedAttribute && properties[BUNDLE_COMPONENTS_PROPERTY] === nextBundleComponents) continue;

            properties[BUNDLE_COMPONENTS_PROPERTY] = nextBundleComponents;
            updates.push(CartJS.updateItemById(item.key, item.quantity, properties));
        }

        await Promise.all(updates);
        return true;
    } catch (error) {
        console.error('Error copying bundle line item properties', error);
        return false;
    }
};

/**
 * Handles the checkout process, setting attributes and verifying advisor selections.
 * @param {Event} e - The event object from the checkout action.
 * @param {boolean} is_advisor_product - Whether the cart contains advisor products
 */
const checkout = async (e, is_advisor_product) => {
    const _this = $(e);
    var $loader = $('.jsc-loader-overlay');
    let isValid = true;
    const containsMainProduct = $('#CartPageForm').data('contains-main-product') || "";
    let cartAttributes = {};

    $loader.show();

    // Terms first (same order as former validateAndCheckout; skip if checkbox not in DOM)
    const $cartTerms = $('#CartTerms');
    if ($cartTerms.length && !$cartTerms.is(':checked')) {
        isValid = false;
        showGenericAlert((vwThemeStrings().checkout && vwThemeStrings().checkout.mustAgreeTermsSales) || '');
    }

    // The demo question is optional. Unanswered values are stored as "-".
    if (isValid && is_advisor_product) {
      $('#jsc-advisor-error-msg').hide();
      const addedAdvisorInfo = await addAdvisorInfoAtLineItemProperties();
      if (!addedAdvisorInfo) isValid = false;
    }

    // After advisor properties are on the lines. The Cart Transform reads them
    // from `_bundle_components.main`, not from the parent line. A failed rewrite
    // is logged and checkout still continues.
    if (isValid) {
        await applyBundleComponentProperties(is_advisor_product);
    }

    if (isValid) {
        // The advisor is kept on the order whenever one was chosen, regardless of
        // the demo answer.
        const advisor = getCheckoutAdvisor();

        cartAttributes["Advisor ID"] = advisor.id;
        cartAttributes["Advisor Name"] = advisor.name;
        cartAttributes["Advisor City"] = advisor.city;
        cartAttributes["Would you like to select a preferred advisor?"] = '';
        if (advisor.id && advisor.id !== '-') cartAttributes.advisor_id = String(advisor.id);
        if (is_advisor_product) {
            cartAttributes[PREVIOUS_DEMO_ATTR] = advisor.demoAnswer;
        } else {
            cartAttributes[PREVIOUS_DEMO_ATTR] = '';
        }

        if (containsMainProduct === true || containsMainProduct === 'true') {
            cartAttributes["Main Product"] = "Yes";
        } else {
            cartAttributes["Main Product"] = "No";
        }

        // ... (Keep existing Customer Info logic) ...
        if (window.theme.customerInfo && window.theme.customerInfo.name != 'Guest') {
            cartAttributes["Customer Name"] = window.theme.customerInfo.name;
            cartAttributes["Customer Email"] = window.theme.customerInfo.email;
            cartAttributes["Customer Address"] = window.theme.customerInfo.address;
            cartAttributes["Customer Postal Code"] = window.theme.customerInfo.postalCode;
            cartAttributes["Customer City"] = window.theme.customerInfo.city;
            cartAttributes["Customer Phone"] = window.theme.customerInfo.phone;
            cartAttributes["Home Phone"] = window.theme.customerInfo.homeNumber;
            cartAttributes["Sales Unit"] = "";
        } else {
            cartAttributes["Customer Name"] = 'Guest';
            cartAttributes["Customer Email"] = '';
            cartAttributes["Customer Address"] = '';
            cartAttributes["Customer Postal Code"] = '';
            cartAttributes["Customer City"] = '';
            cartAttributes["Customer Phone"] = '';
            cartAttributes["Home Phone"] = '';
            cartAttributes["Sales Unit"] = '';
        }


        // cart.requestComplete also fires for cart requests made elsewhere, so
        // bind one-shot and drop any handler left behind by an earlier click.
        bindCheckoutRequestComplete(submitShopifyCheckout);

        try {
            if (Object.keys(cartAttributes).length > 0) {
                CartJS.setAttributes(cartAttributes);
            } else {
                submitShopifyCheckout();
            }
        } catch (error) {
            console.error('Unable to save cart attributes before checkout:', error);
            submitShopifyCheckout();
        }
    } else {
        // console.log('checkout not valid');
        $loader.hide();
    }
};

// start: split payment button
const splitPayment = async (is_advisor_product) => {
    var $loader = $('.jsc-loader-overlay');
    let cartAttributes = {};
    const containsMainProduct = $('#CartPageForm').data('contains-main-product');

    $loader.show();

    let redirectButton = $('.shopify-checkout-btn')
    if ($('.spp2__button-container .spp2__payment-button').length > 0) {
        redirectButton = $('.spp2__button-container .spp2__payment-button');
    }

    // Split payment must click the SPP button, not navigate to /checkout.
    const completeSplitPayment = () => {
        clearCheckoutRequest();
        $loader.hide();
        redirectButton.click();
    };

    let isValid = true;

    // Check terms and conditions
    if (!$('#CartTerms').is(':checked')) {
        $loader.hide();
        showGenericAlert((vwThemeStrings().checkout && vwThemeStrings().checkout.mustAgreeTermsSales) || '');
        return;
    }

    // Add advisor info to line item properties if advisor product
    if (isValid && is_advisor_product) {
        $('#jsc-advisor-error-msg').hide();
        $loader.hide();
        const addedAdvisorInfo = await addAdvisorInfoAtLineItemProperties();
        if (!addedAdvisorInfo) {
            isValid = false;
        }
    }

    if (!isValid) {
        $loader.hide();
        return;
    }

    await applyBundleComponentProperties(is_advisor_product);

    // Set cart attributes (common for both advisor and non-advisor products)
    // The advisor is kept on the order whenever one was chosen, regardless of
    // the demo answer.
    const advisor = getCheckoutAdvisor();

    cartAttributes["Advisor ID"] = advisor.id;
    cartAttributes["Advisor Name"] = advisor.name;
    cartAttributes["Advisor City"] = advisor.city;
    cartAttributes["Would you like to select a preferred advisor?"] = '';
    if (advisor.id && advisor.id !== '-') cartAttributes.advisor_id = String(advisor.id);

    if (is_advisor_product) {
        cartAttributes[PREVIOUS_DEMO_ATTR] = advisor.demoAnswer;
    } else {
        cartAttributes[PREVIOUS_DEMO_ATTR] = '';
    }

    // Main product attribute
    if (containsMainProduct === true || containsMainProduct === 'true') {
        cartAttributes["Main Product"] = "Yes";
    } else {
        cartAttributes["Main Product"] = "No";
    }

    // Customer info cart attributes
    if (window.theme.customerInfo && window.theme.customerInfo.name != 'Guest') {
        cartAttributes["Customer Name"] = window.theme.customerInfo.name;
        cartAttributes["Customer Email"] = window.theme.customerInfo.email;
        cartAttributes["Customer Address"] = window.theme.customerInfo.address;
        cartAttributes["Customer Postal Code"] = window.theme.customerInfo.postalCode;
        cartAttributes["Customer City"] = window.theme.customerInfo.city;
        cartAttributes["Customer Phone"] = window.theme.customerInfo.phone;
        cartAttributes["Home Phone"] = window.theme.customerInfo.homeNumber;
        cartAttributes["Sales Unit"] = "";
    } else {
        cartAttributes["Customer Name"] = 'Guest';
        cartAttributes["Customer Email"] = '';
        cartAttributes["Customer Address"] = '';
        cartAttributes["Customer Postal Code"] = '';
        cartAttributes["Customer City"] = '';
        cartAttributes["Customer Phone"] = '';
        cartAttributes["Home Phone"] = '';
        cartAttributes["Sales Unit"] = '';
    }


    // Submit cart and redirect
    bindCheckoutRequestComplete(completeSplitPayment);

    try {
        if (Object.keys(cartAttributes).length > 0) {
            CartJS.setAttributes(cartAttributes);
        } else {
            completeSplitPayment();
        }
    } catch (error) {
        console.error('Unable to save cart attributes before checkout:', error);
        completeSplitPayment();
    }
};
// end: split payment button

/**
 * Handles the search functionality for advisors based on user input.
 * @param {Object} consultants - The list of consultants fetched from the API.
 */
const onSearchAdvisor = (consultants) => {
    $(document).on('keyup', '#search-advisor', function() {
        $('#jsc-advisor-error-msg').hide();
        const query = $(this).val().toLowerCase();
        const alphanumericRegex = /^[a-z0-9]+$/i;

        if (query !== '' && alphanumericRegex.test(query)) {
            const filteredConsultants = consultants.consultantSg.filter(consultant => {
                const consultantId = consultant["consultant'sId"].toString();
                const consultantName = consultant["consultant'sName"].toLowerCase();
                return consultantId.includes(query) || consultantName.includes(query);
            });

            $('#advisor-search-results').empty();
            if (filteredConsultants.length > 0) {
                filteredConsultants.forEach(consultant => {
                    const _c = vwThemeStrings().consultant || {};
                    const resultHtml = `
                        <div class="padding-10 advisor-row cursor" onclick="selectAdvisor(this, '${consultant["consultant'sId"]}')"> 
                            <span class="cursor">${_c.idLabel || ''} <b>${consultant["consultant'sId"]}</b></span><br>
                            <span class="cursor">${_c.nameLabel || ''} <b>${consultant["consultant'sName"]}</b></span>
                        </div>`;
                    $('#advisor-search-results').append(resultHtml);
                });
            } else {
                $('#advisor-search-results').append('<div class="advisor-not-found">' + ((vwThemeStrings().consultant && vwThemeStrings().consultant.noMatching) || '') + '</div>');
            }
        } else {
            $('#advisor-search-results').empty();
        }
    });
};

/**
 * Selects an advisor from the search results and updates the input field.
 * @param {HTMLElement} e - The clicked element representing the selected advisor.
 * @param {string} id - The ID of the selected advisor.
 */
const selectAdvisor = (e, id) => {
    $('#advisor-search-results').empty();
    $('#search-advisor').val(id);
    localStorage.setItem('Advisor ID', id);
};

/**
 * Retrieves advisor-related information from local storage and updates the UI accordingly.
 */
const getAdvisorLocalStorage = () => {
    const demoValue = localStorage.getItem(PREVIOUS_DEMO_ATTR);
    const is_demo = demoValue ? demoValue.toLowerCase() : demoValue;
    const advisor_id = localStorage.getItem('Advisor ID');

    // An unanswered demo question is valid, so neither radio is pre-selected
    // unless the shopper already answered or arrived through a referral link.
    if (is_demo === 'yes' || (is_demo !== 'no' && hasReferralAdvisor())) {
        $('#demo-yes').prop('checked', true).trigger('change');
    } else if (is_demo === 'no') {
        $('#demo-no').prop('checked', true).trigger('change');
    } else {
        localStorage.setItem(PREVIOUS_DEMO_ATTR, '-');
    }

    if (advisor_id && advisor_id !== '-') {
        $('#search-advisor').val(advisor_id);
    }

    syncAdvisorSelectDisplay();
};

// Scripts for Advisor feature ends here

// start: Product image - Gallery modal
initGalleryModal = (modal, _this, mainSliderArgs, productId, Slideshow) => {
    // console.log('initGalleryModal');
    var tabs = modal.querySelectorAll('[data-tab]');
    const mainThumbnail = modal.querySelector(`#ProductThumbnail-gallery-media-modal-section`);
    const mainFlickity = modal.querySelector(`#ProductPhotos-gallery-media-modal-section`);
    if (localStorage.getItem('productId') !== productId) {
        if (mainThumbnail) {
            const clonedThumbnail = mainThumbnail.cloneNode(true);
            localStorage.setItem('clonedThumbnail', clonedThumbnail.outerHTML);
        }
        if (mainFlickity) {
            const clonedFlickity = mainFlickity.cloneNode(true);
            localStorage.setItem('clonedFlickity', clonedFlickity.outerHTML);
        }
        localStorage.setItem('productId', productId);
    }

    // init gallery modal tab
    if (tabs) {
        tabs.forEach(tab => {
            tab.addEventListener('click', function(event) {
                const tabName = event.currentTarget.getAttribute('data-tab');

                /* start: active tab color */
                tabs.forEach(sibling => {
                    sibling.classList.remove('is-active');
                });

                tab.classList.add('is-active');
                /* end: active tab color */

                /* start: destroy flickity */
                if (_this.flickity && typeof _this.flickity.destroy === 'function') {
                    _this.flickity.destroy();
                    // console.log('flickity destroy');
                }
                /* end: destroy flickity */

                /* start: clone thumbnail flickity */
                var thumbnailFlickity = modal.querySelector(`#ProductThumbnail-gallery-media-modal-section`);

                if (thumbnailFlickity) {
                    clonedFlickity('clonedThumbnail', tabName, 'product__thumb-item', thumbnailFlickity, _this, mainSliderArgs);
                }
                /* end: clone thumbnail media flickity */

                /* start: clone main product media flickity */
                var galleryModalFlickity = modal.querySelector(`#ProductPhotos-gallery-media-modal-section`);

                if (galleryModalFlickity) {
                    clonedFlickity('clonedFlickity', tabName, 'product-main-slide', galleryModalFlickity, _this, mainSliderArgs, Slideshow);
                }
                /* end: clone main product media flickity */
            })
        })
    }
}
// end: Product image - Gallery modal


clonedFlickity = (name, tabName, slideClass, flickityElement, _this, mainSliderArgs, Slideshow=null) => {
    // console.log('clonedFlickity: ', name);
    const storedElementHTML = localStorage.getItem(name);
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = storedElementHTML;
    const retrievedElement = tempDiv.firstChild;
    retrievedElement.classList.add(name);

    const slideElement = retrievedElement.querySelectorAll(`.${slideClass}`);

    let currentThumbnailIndex = -1;
    slideElement.forEach(function(slide, index) {
        if (tabName == 'image' && slide.dataset.mediaType !== 'image') {
            slide.remove();
        } else if (tabName == 'video' && slide.dataset.mediaType !== 'video'){
            slide.remove();
        } else if (name == 'clonedThumbnail') {
            currentThumbnailIndex += 1
            slide.setAttribute('data-index', currentThumbnailIndex);
        }
    })

    flickityElement.parentNode.insertBefore(retrievedElement, flickityElement);
    flickityElement.remove();
    retrievedElement.classList.remove(name);

    if (mainSliderArgs) {
        if (name == 'clonedThumbnail') {
            mainSliderArgs.childNav = retrievedElement
        } else if (name == 'clonedFlickity' && Slideshow != null) {
            _this.flickity = new Slideshow(retrievedElement, mainSliderArgs);
            setTimeout(() => {
                _this.flickity.resize()
            }, 100)
            _this.initImageZoom();
        }
    }
}

observeTabVisibility = (blockId) => {
    const sectionClass = 'section--' + blockId;
    const $sliderWrap = $(`.${sectionClass}.text-columns--slider`);
    if (!$sliderWrap.length) return;

    // Check if this slider lives inside a tab panel at all
    const $tabPanel = $sliderWrap.closest('.jsc-account-hub__tab-panel');
    if (!$tabPanel.length) return; // Not in a tab — skip observer, load path handles it

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'class'
            ) {
                const isActive = $tabPanel.hasClass('jsc-account-hub__tab-panel--active');
                if (isActive) {
                    // Give Flickity one frame to register the tab is now visible
                    requestAnimationFrame(() => {
                        if (Flickity.data($sliderWrap.find('.text-columns__flickity-slider')[0])) {
                            Flickity.data($sliderWrap.find('.text-columns__flickity-slider')[0]).resize();
                        }
                        requestAnimationFrame(() => setSliderEqualHeight(blockId));
                    });
                }
            }
        }
    });

    observer.observe($tabPanel[0], {
        attributes: true,
        attributeFilter: ['class'],
    });
};

setSliderEqualHeight = (blockId) => {
    if (!blockId) return;

    const sectionClass = 'section--' + blockId;
    const $sliderWrap = $(`.${sectionClass}.text-columns--slider`);
    if (!$sliderWrap.length) return;
    if (!$sliderWrap.is(':visible')) return;

    const $flickityEl = $sliderWrap.find('.text-columns__flickity-slider');
    const $slides = $sliderWrap.find('.text-columns-item');

    if (!$slides.length) {
        setTimeout(() => setSliderEqualHeight(blockId), 50);
        return;
    }

    const flktyInstance = $flickityEl.length ? Flickity.data($flickityEl[0]) : null;

    $slides.css('height', 'auto');

    requestAnimationFrame(() => {
        let maxHeight = 0;
        $slides.each(function () {
            const h = this.getBoundingClientRect().height;
            if (h > maxHeight) maxHeight = h;
        });

        if (maxHeight === 0) {
            setTimeout(() => setSliderEqualHeight(blockId), 50);
            return;
        }

        $slides.css('height', `${maxHeight}px`);

        if (flktyInstance) {
            requestAnimationFrame(() => {
                flktyInstance.resize();
            });
        }
    });
};

initTextColumnsFlickity = () => {
    if (typeof Flickity === 'undefined') return;

    const flickityInstances = [];

    $('.text-columns__flickity-slider').each(function () {
        const slider = this;
        const $slider = $(slider);
        const setEqualHeight =
            $slider.data('set-equal-height') === true ||
            $slider.data('set-equal-height') === 'true';
        const blockId = $slider.data('block-id') || '';

        const flkty = new Flickity(slider, {
            cellAlign: 'left',
            freeScroll: true,
            wrapAround: true,
            adaptiveHeight: true,
            prevNextButtons: true,
            pageDots: true,
        });

        flickityInstances.push({ flkty, blockId, setEqualHeight });

        if (setEqualHeight && blockId) {
            // Watch for tab activation if inside a tab panel
            observeTabVisibility(blockId);

            // Window resize / orientation always re-equalises
            $(window).on('resize orientationchange', () => {
                setSliderEqualHeight(blockId);
            });
        }
    });

    const resizeAll = () => {
        for (const { flkty, blockId, setEqualHeight } of flickityInstances) {
            flkty.resize();
            requestAnimationFrame(() => {
                if (setEqualHeight && blockId) {
                    setSliderEqualHeight(blockId);
                } else {
                    flkty.resize();
                }
            });
        }
    };

    if (document.readyState === 'complete') {
        requestAnimationFrame(resizeAll);
    } else {
        window.addEventListener('load', () => requestAnimationFrame(resizeAll), { once: true });
    }
};

// Start of Storepoint customisation
bindFunction = () =>{
    $('.stpt-marker').attr('onclick', 'triggerMapPopup()');
    $('.storepoint-location').attr('onclick', 'triggerMapPopup()');
    if ($('#storepoint-container').length) {
        var $loader = $('.jsc-loader-overlay');
        $loader.hide();
    }
}

eventListnerTriggerPopup = () =>{
    $('body').on('click', '.storepoint-location, .stpt-marker', function() {
        triggerMapPopup();
    });
    $('.mapboxgl-ctrl-geocoder--input').on('keydown', function(event) {
        if (event.key === 'Enter') {
            triggerMapPopup();
        }
    });
}
triggerMapPopup = () => {
    setTimeout(() => {
        // Safety check
        if ($('.street-address').length && $('.storepoint-popup-description').length) {
            $('.street-address').insertBefore($('.storepoint-popup-description'));
        }
    
        var languages = [];
        var _id = '';
        var _location = null; 

        $('.tag-text').each(function(){
            var _this = $(this);
            var text = _this.text();

            _location = _this;
            
            if (text.includes('id_') || text.includes('Id_')) {
                _this.parents('span.tag').hide();
                _id = text.split('_')[1];
            } else if (text.includes('food_') || text.includes('Food_')) {
                _this.text(text.split('_')[1]);
            } else if (text.includes('language_') || text.includes('Language_')) {
                var language = text.split('_')[1];
                languages.push(language);
                _this.parents('span.tag').hide();
            }
        });

        // CRITICAL FIX: We added this check. 
        // If _location is still null, we STOP here so the script doesn't crash.
        if (_location) {
            var uniqueLanguanges = Array.from(new Set(languages));
            var html = `<div class="jsc-language text-left m-b-10 hide">`;
            uniqueLanguanges.forEach(element => {
                html += `<span class="uppercase m-r-5">${element}</span>`
            });
            html += `</div>`;
            
            if (!_location.parents('.storepoint-location-popup').find('.jsc-language').length) {
                _location.parents('.storepoint-location-popup').prepend(html);
            }
            if ($(`.tag-id_${_id}`).length && !$(`.tag-id_${_id}`).parents('.storepoint-location').find('.jsc-language').length) {
                $(`.tag-id_${_id}`).parents('.storepoint-location').prepend(html);
            }
            
            var current_name = _location.parents('.storepoint-location-popup').find('b').text();
            var current_id = localStorage.getItem('Advisor ID');
            
            if(current_id == _id ) {
                $('.jsc-select-btn').attr('disabled','disabled').text('Selected');
            }
        }
    }, 60);
}

selectMapAdvisor = async (e, id, name, profileImg) =>{
    console.log('selectMapAdvisor', e);
    console.log('id', id);
    console.log('name', name);
    console.log('profileImg', profileImg);
    // Use updateAdvisorData function to handle all advisor data updates
    let profilePicture = (!profileImg || profileImg === '-') ? '' : profileImg;
    let advisorCity = '';

    const advisorValidation = await validateAdvisor(id);
    if (advisorValidation.isValid) {
        advisorCity = advisorValidation.advisorCity || '';
        if (!profilePicture && advisorValidation.profilePicture) {
            profilePicture = advisorValidation.profilePicture;
        }
    }

    updateAdvisorData(id, name, profilePicture, false, advisorCity);

    // Update button state
    $(e).prop('disabled', true).text(vorwerkStorepointWidgetStrings().selectedLocationButtonText || 'Selected');
    // console.log('ppokee', getUrlParameter('advisor'));

    if (getUrlParameter('advisor') == 'cart') {
        $(document).on('cart.requestComplete', function(event, cart) {
            location.href = window.theme.urls.toStoreUrl('cart');
        });
    } else {
        $(document).on('cart.requestComplete', function(event, cart) {
            if (id && id !== '-') {
                location.href = window.theme.urls.toStoreUrl('pages/storepoint-turkiye/id_' + id);
            } else {
                location.href = window.theme.urls.toStoreUrl('');
            }
        });
    }
    
    var storepointID = window.location.href.split('selected=')[1];
    //console.log('storepointID 1',storepointID);
    localStorage.setItem('Advisor Storepoint ID', storepointID);
}

getUrlParameter = (name) =>{
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(window.location.href);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// End of Storepoint customisation


// start: pdpa function
// track bank account name checkbox
$('#bank_account_name_checkbox').on('change', function() {
    if ($(this).prop('checked')) {
        var full_name = $('#full_name').val();
        if (full_name != '') {
            $('#bank_account_name').val(full_name);
            $('#bank_account_name').addClass('jsc-disable-field');
            $('#bank_account_name_checkbox_error').css('display', 'none');
        } else {
            $('#bank_account_name_checkbox_error').css('display', 'block');
        }
    } else {
        $('#bank_account_name').removeClass('jsc-disable-field');
        $('#bank_account_name_checkbox_error').css('display', 'none');
    }
});
// track mobile number
$('#jsc-telephone').on('focus input', function() {
    $phoneInput = $('#jsc-telephone');
    let value = $phoneInput.val();

      if (value.startsWith('+65')) {
        $phoneInput.val('+65' + value.slice(3).replace(/\D/g, ''));
      } else {
        $phoneInput.val('+65');
      }
});
// track full name
$('#full_name').on('input', function() {
    if ($('#bank_account_name_checkbox').prop('checked')) {
        var full_name_val = $('#full_name').val();
        $('#bank_account_name').val(full_name_val);
    }
});
// track postal code
$('#postal_code').on('input', function() {
    $postal_code = $('#postal_code');

    if ($postal_code.val().length > 6) {
        $postal_code.val($postal_code.val().slice(0, 6));
    }
});
/* intl-tel-input library: https://intl-tel-input.com/examples/validation.html */
initIntlTelInput = () => {
    if (typeof window.intlTelInput !== 'function') {
        return;
    }
    const input = document.querySelector("#register_mobile");
    if (!input) {
        return;
    }
    // initialise plugin
    intlTelInstance['iti'] = window.intlTelInput(input, {
        initialCountry: "my",
        loadUtilsOnInit: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js",
        separateDialCode: true, // Display country code separately
        nationalMode: false,    // Use full international number format
    });
    // console.log('intlTelInstance: ', intlTelInstance);
}
fetchNationality = () => {
    fetch('https://cdn.shopify.com/s/files/1/0717/2305/7409/files/jsc-nationality-list.json')
        .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(nationalities => {
            // console.log(nationalities);
            if (nationalities.length > 0) {
                $.each(nationalities, function(index, item) {
                    const listItem = $('<option></option>').text(item.Nationality).val(item.Nationality);
                    const nationalityData = $('#nationality').attr('data-default') ? $('#nationality').attr('data-default').toLowerCase() : $('#nationality').attr('data-default');
                    if (item.Nationality && item.Nationality.toLowerCase() === nationalityData) {
                        listItem.prop('selected', true);
                    }
                    $('#nationality').append(listItem);
                });
            }
        })
        .catch(error => {
            // console.error('Fetch nationality error:', error);
        });
}
fetchSGBankList = () => {
    fetch('https://cdn.shopify.com/s/files/1/0717/2305/7409/files/jsc-sg-bank-list.json?v=1733284205')
        .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(availableBank => {
            // console.log(availableBank);
            if (availableBank.length > 0) {
                $.each(availableBank, function(index, bank) {
                    const listItem = $('<option></option>').text(bank['Reporting Institutions']).val(bank['Reporting Institutions']);
                    const bankData = $('#bank_name').attr('data-default') ? $('#bank_name').attr('data-default').toLowerCase() : $('#bank_name').attr('data-default');
                    if (bank['Reporting Institutions'] && bank['Reporting Institutions'].toLowerCase() === bankData) {
                        listItem.prop('selected', true);
                    }
                    $('#bank_name').append(listItem);
                });
            }
        })
        .catch(error => {
            // console.error('Fetch nationality error:', error);
        });
}
enableAccountUpdateWhenFoundChanges = () =>{
    fetchNationality();
    fetchSGBankList();
    // Get the input elements
    // accepts marketing inputs: #accepts_marketing_email, #accepts_marketing_sms, #accepts_marketing_post, #accepts_marketing_telephone
    var accountPagePdpaInputs = $("#alias, #email, #full_name, #nationality, #register_mobile, #register_home, #postal_code, #address_1, #address_2, #bank_name, #bank_account_name, #bank_account_name_checkbox, #bank_account_number, #accepts_policy");

    // Get the submit button
    var updatePdpaButton = $("#update-profile");

    if ($('#bank_account_name_checkbox').prop('checked')) {
        var full_name = $('#full_name').val();
        if (full_name != '') {
            $('#bank_account_name').val(full_name);
            $('#bank_account_name').addClass('jsc-disable-field');
        } else {
            $('#bank_account_name_checkbox').prop('checked', false);
        }
    }

    // Store the initial values
    var initialValues = {};
    accountPagePdpaInputs.each(function () {
      if ($(this).is(":checkbox")) {
        initialValues[this.id] = $(this).prop("checked");
      } else {
        initialValues[this.id] = $(this).val();
      }
    });

    // Add event listener to all input fields
    accountPagePdpaInputs.on("input change", function () {
      var allValuesMatch = accountPagePdpaInputs.toArray().every(function (input) {
        if ($(input).is(":checkbox")) {
          // For checkboxes, check the "checked" property
          return $(input).prop("checked") === initialValues[input.id];
        } else {
          // For other input types, check the "value" property
          return $(input).val() === initialValues[input.id];
        }
      });

      // Enable or disable the submit button based on whether any values have changed
      updatePdpaButton.prop("disabled", allValuesMatch);
    });
}
customerInfoValidation = ($email, $full_name, $nationality, $register_mobile, $register_home) => {
    var $passValidation = true;

    // 1. Email Check
    if ($email == '') {
        $('#email_error').show();
        $passValidation = false;
    } else {
        $('#email_error').hide();
        if ($email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
            $('#email_format_error').hide();
        } else {
            $('#email_format_error').show();
            $passValidation = false;
        }
    }

    // 2. Name Check
    if ($full_name == '') {
        $('#full_name_error').show();
        $passValidation = false;
    } else {
        $('#full_name_error').hide();
    }

    // 3. Nationality Check
    if ($nationality == '') {
        $('#nationality_error').show();
        $passValidation = false;
    } else {
        $('#nationality_error').hide();
    }

    // 4. CLEAN MOBILE CHECK (Removed the console.log that was crashing)
    if ($register_mobile.trim() == '') {
        $('#register_mobile_error').show();
        $passValidation = false;
    } else {
        $('#register_mobile_error').hide();
        $('#register_mobile_format_error').hide();
    }

    return $passValidation;
}
addressValidation = ($address_1, $postal_code) => {
    var $passValidation = true;
    if ($address_1 == '') {
        $('#address_1_error').show();
        $passValidation = false;
    } else {
        $('#address_1_error').hide();
    }

    // console.log('pos: ', $postal_code);
    if ($postal_code == ''){
        $('#postal_code_error').show();
        $passValidation = false;
    } else {
        $('#postal_code_error').hide();
        // https://en.wikipedia.org/wiki/Postal_codes_in_Singapore (consisted of six digits since 1995)
        // https://gist.githubusercontent.com/jamesbar2/1c677c22df8f21e869cca7e439fc3f5b/raw/21662445653ac861f8ab81caa8cfaee3185aed15/postal-codes.json (postal code regex)
        if ($postal_code.match(/^\d{6}$/)) {
            $('#postal_code_format_error').hide();
        } else {
            $('#postal_code_format_error').show();
            $passValidation = false;
        }
    }

    return $passValidation;
}
bankValidation = ($bank_name, $bank_account_name, $bank_account_number) => {
    var $passValidation = true;
    if ($bank_name == '') {
        $('#bank_name_error').show();
        $passValidation = false;
    } else {
        $('#bank_name_error').hide();
    }

    if ($bank_account_name == '') {
        $('#bank_account_name_error').show();
        $passValidation = false;
    } else {
        $('#bank_account_name_error').hide();
    }

    if ($bank_account_number == '') {
        $('#bank_account_number_error').show();
        $passValidation = false;
    } else {
        $('#bank_account_number_error').hide();
        if ($bank_account_number.length >= 7 && $bank_account_number.length <= 15) {
            $('#bank_account_number_format_error').hide();
        } else {
            $('#bank_account_number_format_error').show();
            $passValidation = false;
        }
    }

    return $passValidation;
}
acceptsMarketingValidation = ($accepts_marketing_email, $accepts_marketing_sms, $accepts_marketing_post, $accepts_marketing_telephone) => {
    var $passValidation = true;
    var show_accepts_marketing_error = true;
    if ($accepts_marketing_email || $accepts_marketing_sms || $accepts_marketing_post || $accepts_marketing_telephone) {
        show_accepts_marketing_error = false
    }
    if (show_accepts_marketing_error) {
        $('#accepts_marketing_error').show();
        $passValidation = false;
    } else {
        $('#accepts_marketing_error').hide();
    }

    if ($accepts_marketing_sms) {
        if (intlTelInstance['iti'].isValidNumberPrecise()) {
            $('#accepts_marketing_sms_error').hide();
        } else {
            $('#accepts_marketing_sms_error').show();
            $passValidation = false;
        }
    }

    return $passValidation;
}
advisorCustomerAPI = (id, em, advid, recid, recn, fn, nt, mo, ho, add, add2, pc, ctry, nob, accn, accnum, lang, spec, alias, sendEmail, mce, mcs, mct, lat, lng) =>{
    let $data = {
        id: id,
        advisor_id: advid,
        last_name: fn,
        address: add,
        address2: add2,
        country: ctry,
        postal_code: pc,
        email: em,
        mobile: mo,
        home: ho,
        nationality: nt,
        bank_name: nob,
        bank_account_name: accn,
        bank_account_number: accnum,
        recruiter_id: recid,
        recruiter_name: recn,
        language: lang,
        specialities: spec,
        alias: alias,
        send_email: sendEmail,
        email_marketing_consent: mce,
        sms_marketing_consent: mcs,
        tel_marketing_consent: mct,
        latitude: lat,   // Verified: This is correct
        longitude: lng   // Verified: This is correct
    };
    
    $.ajax({
        // PASTE YOUR NEW URL FROM STEP 3 HERE
        url: "https://webhooks.mechanic.dev/9268887a-f4ed-4055-acfc-4579d9c851e7", 
        method: "POST",
        headers: {
            "content-type": "application/json",
        },
        data: JSON.stringify($data)
    });
}
customerAPI = (id, add, add2, pc, ctry) => {
    let $data = {
        id: id,
        address: add,
        address2: add2,
        country: ctry,
        postal_code: pc
    };

    $.ajax({
        url: "https://webhooks.mechanic.dev/7f87e529-5829-42e3-b01c-0534bde2ca4b", //user/custom/update
        method: "POST",
        headers: {
            "content-type": "application/json",
        },
        data: JSON.stringify($data)
    });
}
updatePdpaAdvisor = (evt,is_tm4u) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $shopifyId = parseInt($('#jsc-customer-id').val());

    var $full_name = $('#full_name').val();
    var $nric = $('#nric').val();
    var $nationality = $('#nationality').val();
    var $register_mobile = $('#register_mobile').val();
    var $register_home = $('#register_home').val();
    var $alias = $('#alias').val();

    var $address_1 = $('#address_1').val();
    var $address_2 = $('#address_2').val();
    var $postal_code = $('#postal_code').val();
    var $address_country_code = $('#address_country_code').val();
    
    // --- 1. GRAB GPS DATA (Crucial Step!) ---
    var $advisor_latitude = $('#advisor_latitude').val();
    var $advisor_longitude = $('#advisor_longitude').val();

    var $bank_name = $('#bank_name').val();
    var $bank_account_name = $('#bank_account_name').val();
    var $bank_account_number = $('#bank_account_number').val();

    var $advisor_language = $('#language_label').text().replace('Language', '');
    var $advisor_specialities = $('#specialities_label').text().replace('Specialities', '');

    var $accepts_policy = $('#accepts_policy').prop("checked");

    var $email = $('#email').val();
    var $advisor_id = $('#advisor_id').val();
    var $recruiter_id = $('#recruiter_id').val();
    var $recruiter_name = $('#recruiter_name').val();

    // Use the safe validation we added earlier
    var $isvalidatedCustomerInfo = customerInfoValidation($email, $full_name, $nationality, $register_mobile, $register_home);
    var $isvalidatedAddress = addressValidation($address_1, $postal_code);
    var $isvalidatedBank = bankValidation($bank_name, $bank_account_name, $bank_account_number);

    var $isvalidatedAcceptsCondition = true;
    if (!$accepts_policy) {
        $('#accepts_policy_error').show();
        $isvalidatedAcceptsCondition = false;
    } else {
        $('#accepts_policy_error').hide();
    }

    var $isvalidatedAdvisorLanguage = true;
    if (!is_tm4u) {
        if ($advisor_language == '') {
            $isvalidatedAdvisorLanguage = false;
            $('#language_blank_error').show();
        } else {
            $('#language_blank_error').hide();
            $('#language_error').hide();
        }
    }

    var $isvalidatedAdvisorSpecialities = true;
    if (!is_tm4u) {
        if ($advisor_specialities == '') {
            $isvalidatedAdvisorSpecialities = false;
            $('#specialities_blank_error').show();
        } else {
            $('#specialities_blank_error').hide();
            $('#specialities_error').hide();
        }
    }

    var $send_update_email = true;
    var $email_marketing_channel = '';
    var $sms_marketing_channel = '';
    var $tel_marketing_channel = '';
    var $isvalidatedAcceptsMarketing = true;

    if (is_tm4u) {
        $send_update_email = false;
        var $email_marketing_channel = $('#marketing_channel_email').prop("checked").toString().toLowerCase();
        var $sms_marketing_channel = $('#marketing_channel_sms').prop("checked").toString().toLowerCase();
        var $tel_marketing_channel = $('#marketing_channel_telephone').prop("checked").toString().toLowerCase();
        if ($sms_marketing_channel == 'false') {
            $isvalidatedAcceptsMarketing = false;
        }
    }
    if (!$isvalidatedAcceptsMarketing) {
        $('#accepts_marketing_error').show();
    } else {
        $('#accepts_marketing_error').hide();
    }

    if ($isvalidatedCustomerInfo && $isvalidatedAddress && $isvalidatedBank && $isvalidatedAcceptsCondition && $isvalidatedAdvisorLanguage && $isvalidatedAdvisorSpecialities && $isvalidatedAcceptsMarketing) {
        
        // --- SAFE PHONE FORMATTING START (Crash Proof) ---
        if (typeof intlTelInstance !== 'undefined' && intlTelInstance['iti']) {
            const intlTelCountryData = intlTelInstance['iti'].getSelectedCountryData();
            if (intlTelCountryData && intlTelCountryData.dialCode) {
                const dialCode = `+${intlTelCountryData.dialCode}`;
                if ($register_mobile && !$register_mobile.includes(dialCode)) {
                    $register_mobile = `+${intlTelCountryData.dialCode}${$register_mobile}`;
                }
            }
        }
        // --- SAFE PHONE FORMATTING END ---

        // --- 2. SEND DATA TO MECHANIC (Now includes GPS!) ---
        advisorCustomerAPI($shopifyId,
            $email, $advisor_id, $recruiter_id, $recruiter_name,
            $full_name, $nationality, $register_mobile, $register_home,
            $address_1, $address_2, $postal_code, $address_country_code,
            $bank_name, $bank_account_name, $bank_account_number,
            $advisor_language, $advisor_specialities, $alias, $send_update_email,
            $email_marketing_channel, $sms_marketing_channel, $tel_marketing_channel,
            $advisor_latitude, $advisor_longitude  // <--- HERE IS THE KEY CHANGE
        )
        
        setTimeout(() => {
            $loader.hide();
            if (is_tm4u) {
                var product_link = $(evt).attr('data-product-link');
                if (product_link) { 
                    if (/^https?:\/\//i.test(product_link) || product_link.indexOf('//') === 0) {
                        window.location.href = product_link;
                    } else {
                        window.location.href = window.theme.urls.toStoreUrl(product_link.replace(/^\/+/, ''));
                    }
                }
            } else {
                location.reload();
            }
        }, 15000);
    } else {
        $loader.hide();
    }
}
updatePdpa = (evt) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $shopifyId = parseInt($('#jsc-customer-id').val());

    var $address_1 = $('#address_1').val();
    var $address_2 = $('#address_2').val();
    var $postal_code = $('#postal_code').val();
    var $address_country_code = $('#address_country_code').val();

    var $accepts_policy = $('#accepts_policy').prop("checked");

    var $isvalidatedAddress = addressValidation($address_1, $postal_code);

    var $isvalidatedAcceptsCondition = true;
    if (!$accepts_policy) {
        $('#accepts_policy_error').show();
        $isvalidatedAcceptsCondition = false;
    } else {
        $('#accepts_policy_error').hide();
    }

    // console.log('isvalidatedAddress: ', $isvalidatedAddress);

    if ($isvalidatedAddress && $isvalidatedAcceptsCondition) {
        customerAPI($shopifyId,
            $address_1, $address_2, $postal_code, $address_country_code
        )
        setTimeout(() => {
            $loader.hide();
            location.reload();
        }, 4500);
    } else {
        $loader.hide();
    }
}
openOptions = (e) => {
    const _this = $(e);
    const optionsEl = _this.siblings('.custom-options');
    _this.toggleClass('active');
    optionsEl.toggleClass('d-none');
}
// track specialities
updateSpecialities = (e) => {
    const _this = $(e);
    const specialitiesLabel = $('#specialities_label').text();
    var specialitiesArr = specialitiesLabel.split(',');
    var addSpecialities = false;

    if (_this.prop("checked")){
        addSpecialities = true;
    }

    if (addSpecialities && specialitiesLabel != 'Specialities') {
        specialitiesArr.push(_this.val());
    } else if (addSpecialities && specialitiesLabel == 'Specialities') {
        specialitiesArr.push(_this.val());
        specialitiesArr = specialitiesArr.filter(function(item) {
            return item !== 'Specialities';
        });
    }

    if (addSpecialities === false) {
        specialitiesArr = specialitiesArr.filter(function(item) {
            return item !== _this.val();
        });
    }

    if (specialitiesArr.length <= 0) {
        $('#specialities_blank_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    }else if (specialitiesArr.length > 3) {
        $('#specialities_blank_error').hide();
        $('#specialities_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    } else {
        $('#specialities_blank_error').hide();
        $('#specialities_error').hide();
        $('#specialities_label').text(specialitiesArr.join(','));
        if ($('#update-profile').prop("disabled")) {
            $('#update-profile').prop("disabled", false);
        }
    }
};
// track language
updateLanguage = (e) => {
    const _this = $(e);
    const langLable = $('#language_label').text();
    var langArr = langLable.split(',');
    var addLang = false;

    if (_this.prop("checked")){
        addLang = true;
    }

    if (addLang && langLable != 'Language') {
        langArr.push(_this.val());
    } else if (addLang && langLable == 'Language') {
        langArr.push(_this.val());
        langArr = langArr.filter(function(item) {
            return item !== 'Language';
        });
    }

    if (addLang === false) {
        langArr = langArr.filter(function(item) {
            return item !== _this.val();
        });
    }

    if (langArr.length <= 0) {
        $('#language_blank_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    }else if (langArr.length > 5) {
        $('#language_blank_error').hide();
        $('#language_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    } else {
        $('#language_blank_error').hide();
        $('#language_error').hide();
        $('#language_label').text(langArr.join(','));
        if ($('#update-profile').prop("disabled")) {
            $('#update-profile').prop("disabled", false);
        }
    }
};
// end: pdpa function
// start: Recover Password Form
showRecoverPasswordForm = () => {
    const recoverPasswordForm = $('#RecoverPasswordForm').attr('aria-hidden');
    // console.log('recoverPasswordForm: ', recoverPasswordForm);
    if (recoverPasswordForm === "true") {
        $('#RecoverPasswordForm').attr('aria-hidden', 'false');
        $('#RecoverPasswordForm').removeClass('hide');
        $('#CustomerLoginForm').addClass('hide');
        $('#CustomerLoginForm').attr('aria-hidden', 'true');
    }
}
hideRecoverPasswordForm = () => {
    const recoverPasswordForm = $('#RecoverPasswordForm').attr('aria-hidden');
    // console.log('recoverPasswordForm: ', recoverPasswordForm);
    if (recoverPasswordForm === "false") {
        $('#RecoverPasswordForm').attr('aria-hidden', 'true');
        $('#RecoverPasswordForm').addClass('hide');
        $('#CustomerLoginForm').removeClass('hide');
        $('#CustomerLoginForm').attr('aria-hidden', 'false');
    }
}
// end: Recover Password Form
// start: section anchor
getAnchorLink = (evt) => {
    var anchorLink = $(evt).attr('href');
    scrollToSection(anchorLink);
}

onloadGetAnchorLink = () => {
    var anchorLink = window.location.hash;
    // console.log('onloadGetAnchorLink: ', onloadGetAnchorLink);
    if(anchorLink != "") {
      scrollToSection(anchorLink);
    }
}

scrollToSection = (link) => {
    var bareLink = String(link || '').replace(/^#/, '');
    if(bareLink === "") {
      return;
    }
    var target = $('[data-anchor="' + link + '"]:first');
    if(target.length === 0) {
      // anchor ids are often saved in the theme editor without the leading "#"
      target = $('[data-anchor="' + bareLink + '"]:first');
    }
    if(target.length === 0) {
      target = $(document.getElementById(bareLink) || []);
    }
    if(target.length > 0) {
      window.location.hash = link;
      var top = target.offset().top - 150;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
}
// end: section anchor
// start: referral link
copyReferralLink = () => {
    // Get the text field
    var referralLink = $('#referral_link')[0];

    // Select the text field
    referralLink.select();
    referralLink.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text inside the text field
    navigator.clipboard.writeText(referralLink.value).then(function() {
        $('#copied-label').fadeIn().delay(1000).fadeOut();
    }).catch(function(error) {
        // console.error("Failed to copy text: " + error);
    });;
};
// end: referral link
checkReferral = async () => {
    const $loader = $('.jsc-loader-overlay');
    // console.log('Checking referral...');
    $loader.show();

    try {
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has('ref')) {
            // console.log('No referral parameter found');
            return;
        }

        // Parse referral data
        const ref = urlParams.get('ref');
        const [refId, refNameEncoded] = ref.split('@');
        const refName = refNameEncoded?.replace(/_/g, ' ') || '';
        // console.log('Referral ID:', refId, 'Name:', refName);

        // Get current advisor data
        const currentAdvisorId = localStorage.getItem('Advisor ID');
        const storedRefId = localStorage.getItem('Referral ID');

        // Check if this is a new referral or different from current advisor
        // const isNewReferral = refId !== storedRefId;
        // const isDifferentAdvisor = refId !== currentAdvisorId;

        // if (!isNewReferral && !isDifferentAdvisor) {
        //     console.log('Referral already set as advisor');
        //     return;
        // }

        // Validate if referral is a valid advisor and get profile picture
        const advisorValidation = await validateAdvisor(refId);

        if (advisorValidation.isValid) {
            updateAdvisorData(
                refId,
                refName,
                advisorValidation.profilePicture,
                true,
                advisorValidation.advisorCity
            );
        } else {
            clearAdvisorData();
        }
    } catch (error) {
        // console.error('Error in checkReferral:', error);
    } finally {
        $loader.hide();
    }
}

const INVALID_ADVISOR_RESULT = Object.freeze({
    isValid: false,
    profilePicture: '',
    advisorCity: '',
    advisorID: '',
});

const normalizeAdvisorId = (id) => String(id || '').replace(/^id_/i, '').toLowerCase();

// Helper function to validate if an ID belongs to a valid advisor and fetch profile picture
const validateAdvisor = async (advisorId) => {
    try {
        const basePath = (window.theme && window.theme.urls && typeof window.theme.urls.toStoreUrl === 'function')
            ? window.theme.urls.toStoreUrl('pages/storepoint-turkiye/id_' + advisorId)
            : '/pages/storepoint-turkiye/id_' + advisorId;
        const response = await fetch(basePath + '?sections=advisor-validate');
        // console.log('validate advisor for referral: ', response.status);

        if (response.status === 404) return INVALID_ADVISOR_RESULT;

        const sections = await response.json();
        const html = sections['advisor-validate'];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const script = doc.querySelector('script[type="application/json"]');
        if (!script) return INVALID_ADVISOR_RESULT;

        const data = JSON.parse(script.textContent);

        const returnedAdvisorId = data.advisor_id || '';
        if (
            returnedAdvisorId &&
            normalizeAdvisorId(advisorId) !== normalizeAdvisorId(returnedAdvisorId)
        ) {
            return INVALID_ADVISOR_RESULT;
        }

        return {
            isValid: true,
            profilePicture: data.profile_picture || '',
            advisorCity: data.advisor_city || '',
            advisorID: returnedAdvisorId,
        };
    } catch (error) {
        return INVALID_ADVISOR_RESULT;
    }
}

const validateExistingAdvisor = async () => {
    const advisorId = localStorage.getItem('Advisor ID');
    if (!advisorId) return;

    const advisorValidation = await validateAdvisor(advisorId);
    if (!advisorValidation.isValid) {
        clearAdvisorData();
    }
}

// Writes advisor_id again after a product is added. Selecting an advisor before
// the cart exists does not leave the attribute on the cart Shopify creates at add.
(function syncAdvisorIdAttribute() {
    if (window.vwAdvisorAttributeSync) return;
    window.vwAdvisorAttributeSync = true;

    function selectedAdvisorId() {
        try {
            var id = localStorage.getItem('Advisor ID');
            if (!id || id === '-' || id === 'null' || id === 'undefined') return '';
            return String(id);
        } catch (e) {
            return '';
        }
    }

    function cartRoot() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    var nativeFetch = window.fetch.bind(window);
    var writing = false;

    function writeAdvisorId(id) {
        writing = true;
        return nativeFetch(cartRoot() + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: { advisor_id: id } })
        }).catch(function () {}).finally(function () { writing = false; });
    }

    function syncAdvisorId() {
        if (writing) return;
        var id = selectedAdvisorId();
        if (!id) return;
        nativeFetch(cartRoot() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
            .then(function (response) { return response.json(); })
            .then(function (cart) {
                if (!cart || !cart.items || !cart.items.length) return;
                if (cart.attributes && String(cart.attributes.advisor_id || '') === id) return;
                return writeAdvisorId(id);
            })
            .catch(function () {});
    }

    window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var pending = nativeFetch.apply(window, arguments);
        if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) return pending;
        return pending.then(function (response) {
            if (response && response.ok) syncAdvisorId();
            return response;
        });
    };

    document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
        var id = selectedAdvisorId();
        if (!id) return;
        var input = form.querySelector('input[name="attributes[advisor_id]"]');
        if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'attributes[advisor_id]';
            form.appendChild(input);
        }
        input.value = id;
    }, true);

    document.addEventListener('cart:updated', syncAdvisorId);
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncAdvisorId);
    } else {
        syncAdvisorId();
    }
})();

// Helper function to update advisor data in localStorage, cart attributes and UI
const updateAdvisorData = (advisorId, advisorName, advisorProfilePicture = '', isReferral = false, advisorCity = '') => {
    // Update localStorage
    localStorage.setItem('Advisor ID', advisorId);
    localStorage.setItem('Advisor Name', advisorName);
    localStorage.setItem('Advisor Profile Picture', advisorProfilePicture);
    localStorage.setItem('Advisor City', advisorCity);
    var storepointID = window.location.href.split('selected=')[1];
    // console.log('storepointID 2',storepointID);
    localStorage.setItem('Advisor Storepoint ID', storepointID);

    // Only update referral localStorage if isReferral is true
    if (isReferral) {
        localStorage.setItem('Referral ID', advisorId);
        localStorage.setItem('Referral Name', advisorName);
    }

    // Update cart attributes
    CartJS.setAttributes({
        'Advisor ID': advisorId,
        'advisor_id': advisorId,
        'Advisor Name': advisorName,
        'Advisor Profile Picture': advisorProfilePicture,
        'Advisor City': advisorCity
    });

    // Update UI if element exists
    const $advisorNameElement = $('#jsc-cart-advisor-name');
    if ($advisorNameElement.length) {
        $advisorNameElement.text(advisorName);
    }

    // Dispatch advisor:selected event for any listeners
    document.dispatchEvent(new CustomEvent('advisor:selected', {
        detail: {
            id: advisorId,
            name: advisorName,
            profileImg: advisorProfilePicture
        }
    }));
}
// Helper function to clear advisor data from localStorage, cart attributes and UI
const clearAdvisorData = () => {
    // Clear localStorage
    localStorage.removeItem('Advisor ID');
    localStorage.removeItem('Advisor Name');
    localStorage.removeItem('Advisor Profile Picture');
    localStorage.removeItem('Advisor City');
    localStorage.removeItem('Referral ID');
    localStorage.removeItem('Referral Name');
    localStorage.removeItem('Advisor Storepoint ID');

    // Clear cart attributes
    CartJS.setAttributes({
        'Advisor ID': '',
        'advisor_id': '',
        'Advisor Name': '',
        'Advisor Profile Picture': '',
        'Advisor City': ''
    });

    // Clear UI if element exists
    const $advisorNameElement = $('#jsc-cart-advisor-name');
    if ($advisorNameElement.length) {
        $advisorNameElement.text('');
    }

    // Clear advisor name input if exists
    const $advisorNameInput = $('#jsc-cart-advisor-name-input');
    if ($advisorNameInput.length) {
        $advisorNameInput.val('');
    }

    // Clear search advisor input if exists
    const $searchAdvisorInput = $('#search-advisor');
    if ($searchAdvisorInput.length) {
        $searchAdvisorInput.val('');
    }

    // Dispatch advisor:cleared event for any listeners
    document.dispatchEvent(new CustomEvent('advisor:cleared'));
}
hideCustomerCartInput = () => {
    const refId = localStorage.getItem('Referral ID');
    const refName = localStorage.getItem('Referral Name');
    if (refId && refName) {
        if (!$('.jsc-customer-input').hasClass('d-none')) {
            $('.jsc-customer-input').addClass('d-none');
        }
        localStorage.setItem(PREVIOUS_DEMO_ATTR, '-');
        localStorage.setItem('Would you like to select a preferred advisor?', '-');
    } else {
        if ($('.jsc-customer-input').hasClass('d-none')) {
            $('.jsc-customer-input').removeClass('d-none');
        }
    }
}
// start: register form
submitRegisterForm = (e) =>{
    // console.log('submitRegisterForm...')
    const password = $('#CreatePassword').val();
    const phone = $('#jsc-telephone').val();
    const address1 = $('#jsc-address1').val();
    const address2 = $('#jsc-address2').val();
    const postalCode = $('#jsc-postal-code').val();
    const $loader = $('.jsc-loader-overlay');
    var passRegister = true;

    $loader.show();
    // console.log('jsc-telephone: ', phone);
    // Check if password length is less than 12
    if (password.length < 12) {
        $('#password-error').show(); // Show error message
        passRegister = false;
    } else {
        $('#password-error').hide(); // Hide error message
    }

    // Check if the phone follow Sinagpore mobile fomat
    if (phone != '' || phone != '+65') {
        $('#phone-blank-error').hide();
        if (phone.match(/^\+65(6|8|9)\d{7}$/)) {
            $('#phone-format-error').hide(); // Show error message
        } else {
            $('#phone-format-error').show(); // Hide error message
            passRegister = false;
        }
    } else {
        $('#phone-blank-error').show();
        passRegister = false;
    }

    // Check address 1
    if (address1 == '') {
        $('#address1-blank-error').show();
        passRegister = false;
    } else {
        $('#address1-blank-error').hide();
    }

    // Check postal code format
    if (postalCode == ''){
        $('#zip-blank-error').show();
        passRegister = false;
    } else {
        $('#zip-blank-error').hide();
        if (postalCode.match(/^\d{6}$/)) {
            $('#zip-format-error').hide();
        } else {
            $('#zip-format-error').show();
            passRegister = false;
        }
    }

    // console.log('passRegister: ', passRegister);
    if(passRegister) {
        $('#register-form-error').hide();
        const formated_address1 = address1.replace(/,/g, '%&%');
        const formated_address2 = address2.replace(/,/g, '%&%');
        const customer_tag = `__tel:${phone},__address1:${formated_address1},__address2:${formated_address2},__zip:${postalCode}`;
        $('#jsc-customer-tag').val(customer_tag);
        setTimeout(() => {
            $('#register-submit').click();
            $loader.hide();
        }, 2000);
    } else {
        $('#register-form-error').show();
        // Find first visible error from known error IDs
        if ($('#register-form-error')) {
            $('html, body').animate({
                scrollTop: $('#register-form-error').offset().top - 100
            }, 500);
        }
        $loader.hide();
    }
}

//start:Pagination
tablePaginate = () =>{
    // if($('#jsc-advisor-report').length > 0) {
    //     $('#jsc-advisor-report').createTablePagination({
    //         rowPerPage: 20,
    //     });
    // }

    // $('#jsc-advisor-report').DataTable({
    //     pageLength: 20,
    //     lengthChange: false
    // });
}
//end:Pagination
limitInput = (input, maxLength) => {
    if (input.value.length > maxLength) {
        input.value = input.value.slice(0, maxLength);
    }
}
// start: faq collapsible
showMoreCollapsible = (e) => {
    const _this = $(e);
    const _container = $(e).parent();
    const _showLessBtn = _this.siblings('.collapsible-show-less');
    const _siblings = _this.siblings('.jsc-faq-collapsible.d-none');
    // console.log('_siblings: ', _siblings)
    if (_siblings.length > 0){
        $.each(_siblings, function(index, element) {
            $(element).removeClass('d-none');
        });
        _this.css('display', 'none');
        _showLessBtn.css('display', 'block');
        _showLessBtn.insertAfter(_container.find('.jsc-faq-collapsible').last());
    }
}
showLessCollapsible = (e) => {
    const _this = $(e);
    const _showMoreBtn = _this.siblings('.collapsible-show-more');
    const _siblings = _this.siblings('.jsc-faq-collapsible');
    $.each(_siblings, function(index, element) {
        $(element).addClass('d-none');
    });
    _this.css('display', 'none');
    _showMoreBtn.css('display', 'block');
}
// end: faq collapsible
initAdvisorSelector = () => {
    const advisorID = localStorage.getItem('Advisor ID');

    if (advisorID && advisorID !== '-') {
        syncAdvisorSelectDisplay();
    }
}
// start: remove customer update error tag
removeProfileUpdateError = () =>{
    var isTriggerRemoveTag = $('#trigger-remove-error').length;
  
    if (isTriggerRemoveTag) {
      var tag_val = $('#trigger-remove-error').val();
      var customer_id = $('#trigger-remove-error').attr('data-id');
    //   alert('tag_val: ' + tag_val + ' id: ' + customer_id)
      let _data = {
        tagsToRemove: tag_val,
        id: customer_id
      };
      $.ajax({
        url: 'https://webhooks.mechanic.dev/f2855272-c9b5-4af1-9620-544149e327e7', // user/custom/remove_tags
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: JSON.stringify(_data)
      }).done(function () {
        
      });
    }
}
// end: remove customer update error tag
// start: onload loader
onLoadLoader = () => {
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    $(window).on('load', function() {
        setTimeout(function() {
            $loader.hide();
        }, 2000);
    });
}
// end: onload loader
// start: tm4u
onloadTm4u = () => {
    assignTm4uLocalStorage();
    redirectTm4uStep2Page();
    // resetDuplicatedTag();
} 
getQueryParam = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}
assignTm4uLocalStorage = () => {
    const tm4uValue = getQueryParam("tm4u");
    if (tm4uValue === "true") {
        localStorage.setItem("tm4u", tm4uValue);
    }

    const comingFrom = getQueryParam("from");
    const newcomerHandles = [
        document.body.dataset.newcomerEarningPath,
        document.body.dataset.newcomerOwnedPath
    ].filter(Boolean).map((path) => path.split('/').filter(Boolean).pop());
    if (newcomerHandles.includes(comingFrom)) {
        localStorage.setItem("tm4u-redirect-link", comingFrom);
    }
}
redirectTm4uStep2Page = () =>{ 
    setTimeout(() => {
        var sp = window.theme.urls.storePathname();
        if (sp === '/pages/advisor-page' || sp === '/account' || sp === '/') {
            if (localStorage.getItem("tm4u") === "true" && localStorage.getItem("tm4u-redirect-link") != "") {
                localStorage.removeItem("tm4u");
                window.location.href = window.theme.urls.toStoreUrl('pages/' + localStorage.getItem("tm4u-redirect-link"));
            }
        }
    }, 900);
}
$(document).on('focus input', '#tm4u_nric_verify', function () {
    const el = this;
    el.value = el.value.replace(/[^\d-]/g, '');
    limitInput(el, 15);
});

tm4uNricDigitsOnly = (value) => String(value || '').replace(/\D/g, '');

isTm4uNricValidForCountry = (rawValue, country) => {
    const trimmed = String(rawValue || '').trim();
    if (!trimmed) return false;
    const digits = tm4uNricDigitsOnly(trimmed);
    const c = String(country || '').trim();
    if (!digits) return false;
    if (c === 'Belgium') return isBelgianNationalRegisterNumberValid(digits);
    if (c === 'Netherlands') return isDutchBsnValid(digits);
    if (c === 'Luxembourg') return isLuxembourgNationalIdValid(digits);
    return false;
};

belgianNationalRegisterChecksumExpected = (nineDigitStr) => {
    const n = Number(nineDigitStr);
    if (!Number.isFinite(n)) return null;
    const mod = n % 97;
    const check = 97 - mod;
    return String(check).padStart(2, '0');
};

tm4uIsUtcCalendarDateValid = (year, month, day) => {
    if (month < 1 || month > 12 || day < 1 || day > 31) return false;
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
};

isBelgianNationalRegisterNumberValid = (digits) => {
    if (digits.length !== 11) return false;
    const yy = parseInt(digits.slice(0, 2), 10);
    const mm = parseInt(digits.slice(2, 4), 10);
    const dd = parseInt(digits.slice(4, 6), 10);
    if (mm < 1 || mm > 12) return false;
    const y19 = 1900 + yy;
    const y20 = 2000 + yy;
    const dateOk19 = tm4uIsUtcCalendarDateValid(y19, mm, dd);
    const dateOk20 = tm4uIsUtcCalendarDateValid(y20, mm, dd);
    if (!dateOk19 && !dateOk20) return false;

    const first9 = digits.slice(0, 9);
    const check = digits.slice(9, 11);
    const expected19 = belgianNationalRegisterChecksumExpected(first9);
    const expected20 = belgianNationalRegisterChecksumExpected(`2${first9}`);
    if (expected19 == null || expected20 == null) return false;

    const matches19 = check === expected19;
    const matches20 = check === expected20;
    if (!matches19 && !matches20) return false;

    if (matches19 && matches20) {
        if (dateOk19 && !dateOk20) return true;
        if (dateOk20 && !dateOk19) return true;
        return false;
    }

    if (matches19) return dateOk19;
    return dateOk20;
};

isDutchBsnValid = (digits) => {
    if (!/^\d+$/.test(digits)) return false;
    let d = digits;
    if (d.length === 8) d = d.padStart(9, '0');
    if (d.length !== 9) return false;
    if (/^(\d)\1{8}$/.test(d)) return false;
    let sum = 0;
    for (let i = 0; i < 8; i++) {
        sum += (9 - i) * parseInt(d[i], 10);
    }
    sum -= parseInt(d[8], 10);
    return sum % 11 === 0;
};

luxembourgIso7064Mod89CheckFrom11Digits = (elevenDigitStr) => {
    let n = 0;
    for (let i = 0; i < elevenDigitStr.length; i++) {
        const digit = parseInt(elevenDigitStr[i], 10);
        if (!Number.isFinite(digit)) return null;
        n = (n * 10 + digit) % 89;
    }
    const check = 89 - (n % 89);
    return String(check).padStart(2, '0');
};

isLuxembourgNationalIdValid = (digits) => {
    if (digits.length !== 13) return false;
    const y = parseInt(digits.slice(0, 4), 10);
    const m = parseInt(digits.slice(4, 6), 10);
    const day = parseInt(digits.slice(6, 8), 10);
    if (y < 1800 || y > 2100 || m < 1 || m > 12 || day < 1 || day > 31) return false;
    if (!tm4uIsUtcCalendarDateValid(y, m, day)) return false;

    const body11 = digits.slice(0, 11);
    const expectedCheck = luxembourgIso7064Mod89CheckFrom11Digits(body11);
    if (expectedCheck == null) return false;
    return digits.slice(11, 13) === expectedCheck;
};

showConfirmation = () =>{
    let nric = $('#tm4u_nric_verify').val();
    // console.log('nric: ', nric, ' validate pass: ', `${/^\d{10}$/.test(nric)}`);
    if (/^\d{10}$/.test(nric)) {
        $('#confirm-nric').text(nric);
        $('#jsc-tm4u-overlay').css('display', 'block');
        $('#jsc-tm4u-popup').show();
    } else {
        $('#nric-digit-error').show();
    }
}
closeConfirmation = () =>{
    $('#jsc-tm4u-overlay').css('display', 'none');
    $('#jsc-tm4u-popup').hide();
}
submitstep2b = (e) =>{
    // click upload NRIC
    $('.cf-submit-form').click();
    
    setTimeout(() => {
        if ($('.cf-step-invalid').length) {
            $('html, body').animate({
                scrollTop: $('.cf-step-invalid').first().offset().top - 120
            }, 500);            
        } else {
            if ($('.jsc-accepts_policy').length === $('.jsc-accepts_policy:checked').length) {
                $('#accepts_policy_error').hide();
                updatePdpaAdvisor(e,true);
                $('html, body').animate({
                    scrollTop: $('.step2b').first().offset().top - 120
                }, 500);
            } else {
                $('#accepts_policy_error').show();
            }
        }
    }, 1200);
}
// end: tm4u
// start: download pdf (print)
triggerDownloadPdf = (e, contentId) => {
    const _this = $(e);
    let $content = $('#' + contentId);
    let divContents = $content.length ? $content.html() : '';

    if (divContents !== '') {
        let styleSheet1 = _this?.attr('data-css1') || '';
        let styleSheet2 = _this?.attr('data-css2') || '';
        let printWindow = window.open('', '', 'height=800,width=800');

        let htmlContent = '<html><head><title>Print E-Business Card</title>';
        if (styleSheet1 !== '') {
            htmlContent += `<link rel="stylesheet" href="${styleSheet1}" preload>`;
        }
        if (styleSheet2 !== '') {
            htmlContent += `<link rel="stylesheet" href="${styleSheet2}" preload>`;
        }
        htmlContent += `</head><body><div class="page-width page-content">${divContents}</div></body></html>`;

        printWindow.document.open();
        printWindow.document.write(htmlContent);
        printWindow.document.close();

        setTimeout(function () {
            printWindow.print();
        }, 1000);
    }
}
// end: download pdf (print)


// start: implement overlay when menu dropdown is open
function toggleMegaMenuOverlay() {
    const detailsList = document.querySelectorAll('.site-nav__details');
    const headerElements = document.querySelectorAll('.site-header__element');
    const mainContent = document.querySelector('.main-content');

    if (detailsList.length === 0 || headerElements.length === 0 || !mainContent) return;

    // Check if ANY dropdown is open
    const isAnyOpen = Array.from(detailsList).some(details => details.hasAttribute('open'));

    if (isAnyOpen) {
      // Full-page blur overlay inside .main-content
      if (!document.querySelector('.jsc-blurred-overlay')) {
        const overlay = document.createElement('div');
        overlay.classList.add('jsc-blurred-overlay');
        mainContent.appendChild(overlay);
      }

      // Light overlays only for first 2 header elements
      headerElements.forEach((headerElement, index) => {
        if (index < 2 && !headerElement.querySelector('.jsc-light-overlay')) {
          const lightOverlay = document.createElement('div');
          lightOverlay.classList.add('jsc-light-overlay');
        //   headerElement.style.position = 'relative';
          headerElement.appendChild(lightOverlay);
        }
      });
  
      document.addEventListener('click', handleOutsideClick);
    } else {
      removeMegaMenuOverlay();
    }
}
  
function removeMegaMenuOverlay() {
    document.querySelector('.jsc-blurred-overlay')?.remove();
    document.querySelectorAll('.jsc-light-overlay').forEach(el => el.remove());

    // Close ALL open details
    document.querySelectorAll('.site-nav__details[open]').forEach(details => {
        details.removeAttribute('open');
    });

    document.removeEventListener('click', handleOutsideClick);
}
  
function handleOutsideClick(event) {
    const detailsList = document.querySelectorAll('.site-nav__details');
    if ([...detailsList].every(details => !details.contains(event.target))) {
    removeMegaMenuOverlay();
    }
}

// --- New close button logic ---
const closeIcons = document.querySelectorAll('.jsc-close-icon');
if (closeIcons.length > 0) {
  closeIcons.forEach(icon => {
    icon.addEventListener('click', (e) => {
      e.preventDefault();
      removeMegaMenuOverlay();
    });
  });
}

// Observe ALL details elements
const targets = document.querySelectorAll('.site-nav__details');
targets.forEach(target => {
    const observer = new MutationObserver(toggleMegaMenuOverlay);
    observer.observe(target, { attributes: true, attributeFilter: ['open'] });
});
// end: implement overlay when menu dropdown is open

//start: disable background scrolling when mobile menu is open
toggleBodyScroll = () => {
    $(document).on('click', '.mobile-nav-trigger', function () {
        if ($('.jsc-mobile-nav-bg-color').hasClass('is-active')) {
          $('body').addClass('no-scroll');
        } else {
          $('body').removeClass('no-scroll');
        }
    });
}
//end: disable background scrolling when mobile menu is open

//start: show disclaimer text for TM and KS product logic
hoverATCbutton = () => {
    $('.jsc-hover-atc-button').hover(
        function () {
            // on hover in
            var $disclaimer_text = $(this).siblings('.jsc-disclaimer-text-for-tm-and-ks');
            $disclaimer_text.fadeIn(200);
        },
        function () {
            // on hover out
            var $disclaimer_text = $(this).siblings('.jsc-disclaimer-text-for-tm-and-ks');
            $disclaimer_text.fadeOut(200);
        }
    );
}
//end: show disclaimer text for TM and KS product logic
// start: show popup when button with mixing restriction is clicked
$(document).on('click', 'button[data-show-mixing-popup="true"]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $this = $(this);
    const sectionId = $this.data('section-id');
    // console.log('sectionId', sectionId);

    if (!sectionId) return;

    const popup = $(`#jsc-mixing-popup-${sectionId}`);
    // console.log('popup', popup);
    if (!popup.length) return;

    const closeButton = popup.find('.jsc-mixing-popup-close');
    const overlay = popup.find('.jsc-mixing-popup-overlay');
    const continueButton = popup.find('.jsc-continue-without-adding');
    const clearCartButton = popup.find('.jsc-clear-cart-and-add');

    // console.log('closeButton', closeButton);
    // console.log('overlay', overlay);

    popup.css('display', 'block');
    $('body').css('overflow', 'hidden');
    $('body').addClass('mixing-popup-open');

    const closePopup = () => {
        popup.css('display', 'none');
        $('body').css('overflow', '');
        $('body').removeClass('mixing-popup-open');
    }

    if (closeButton.length > 0) {
        closeButton.on('click', function(ce) {
            ce.preventDefault();
            ce.stopPropagation();
            closePopup();
        });
    }

    if (overlay.length > 0) {
        overlay.on('click', function(oe) {
            oe.preventDefault();
            oe.stopPropagation();
            closePopup();
        });
    }

    if (continueButton.length > 0) {
        continueButton.on('click', function(ctne) {
            ctne.preventDefault();
            ctne.stopPropagation();
            closePopup();
        });
    }

    if (clearCartButton.length > 0) {
        clearCartButton.on('click', function(ccte) {
            ccte.preventDefault();
            ccte.stopPropagation();
            fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                }
            })
            .then(response => response.json())
            .then(() => {
                // Now submit the form to add the current item
                $this.removeAttr('data-show-mixing-popup');
                $this.trigger('click');
            })
            .catch(error => {
                // console.error('Error clearing cart:', error);
                alert('There was an error processing your request. Please try again.');
            });
        });
    }
});

// end: show popup when button with mixing restriction is clicked
// start: show popup when button with quantity limit restriction is clicked
$(document).on('click', 'button[data-show-quantity-limit-popup="true"]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $this = $(this);
    const sectionId = $this.data('section-id');
    // console.log('sectionId', sectionId);

    if (!sectionId) return;

    const popup = $(`#jsc-quantity-limit-popup-${sectionId}`);
    // console.log('popup', popup);
    if (!popup.length) return;

    const closeButton = popup.find('.jsc-mixing-popup-close');
    const overlay = popup.find('.jsc-mixing-popup-overlay');
    const continueButton = popup.find('.jsc-continue-without-adding');

    // console.log('closeButton', closeButton);
    // console.log('overlay', overlay);

    popup.css('display', 'block');
    $('body').css('overflow', 'hidden');
    $('body').addClass('mixing-popup-open');

    const closePopup = () => {
        popup.css('display', 'none');
        $('body').css('overflow', '');
        $('body').removeClass('mixing-popup-open');
    }

    if (overlay.length > 0) {
        overlay.on('click', function(oe) {
            oe.preventDefault();
            oe.stopPropagation();
            closePopup();
        });
    }

    if (continueButton.length > 0) {
        continueButton.on('click', function(ctne) {
            ctne.preventDefault();
            ctne.stopPropagation();
            closePopup();
        });
    }
});
// end: show popup when button with quantity limit restriction is clicked

/* ========================================================
   CART VALIDATION LOCK (Advisor/Demo Code + Terms -> Checkout)
   ======================================================== */
function initCartValidationLock() {
    const $checkoutBtn = $('#jsc-checkout-btn');
    const $splitPaymentBtn = $('.btn-split-payment');
    const $termsCheckbox = $('#CartTerms');
    
    const disabledStyle = {
        'opacity': '0.5',
        'pointer-events': 'none', 
        'cursor': 'not-allowed',
        'background-color': '#ccc', 
        'border-color': '#ccc'
    };
    
    const enabledStyle = {
        'opacity': '1',
        'pointer-events': 'auto',
        'cursor': 'pointer',
        'background-color': '', 
        'border-color': ''
    };

    function checkCartState() {
        // Get cart page form data
        const $cartForm = $('#CartPageForm');
        if (!$cartForm.length) return;

        let isValid = $termsCheckbox.length ? $termsCheckbox.is(':checked') : true;

        // Apply styles to both checkout and split payment buttons
        if (isValid) {
            $checkoutBtn.css(enabledStyle);
            $splitPaymentBtn.css(enabledStyle);
        } else {
            $checkoutBtn.css(disabledStyle);
            $splitPaymentBtn.css(disabledStyle);
        }
    }

    // Event listeners
    $termsCheckbox.on('change', checkCartState);
    $(document).on('change', '.demo-radio', checkCartState);

    // Initial check
    checkCartState();

    // Periodic check (reduced frequency)
    setInterval(checkCartState, 1000);
}

$(document).ready(function() {
    initCartValidationLock();
});
// start: bundle reconciliation (orphan cleanup only — no GWP metafield auto-heal)
/** Line-item keys added by PWP/GWP bundle flows; strip these instead of removing the paid main line. */
const _BUNDLE_LINE_PROPERTY_KEYS = [
    '_bundle_type',
    '_bundle_id',
    '_bundle_role',
    '_pwp_role',
    '_gwp_role',
    '_bundle_max'
  ];
  
  /**
   * @param {object|null|undefined} props
   * @returns {object}
   */
  const _stripBundleLineProperties = (props) => {
    const strip = new Set(_BUNDLE_LINE_PROPERTY_KEYS);
    const out = {};
    for (const [k, v] of Object.entries(props || {})) {
      if (strip.has(k)) continue;
      out[k] = v;
    }
    return out;
  };
  
  /**
   * Orphan bundle main (no bundle children left): strip `_bundle_type` / `_bundle_id` /
   * `_bundle_role` only for pure GWP mains (`_bundle_type === 'gwp'`). For `mix` or `pwp`
   * mains, PWP is involved — keep those keys and only strip `_pwp_role` / `_gwp_role`.
   *
   * @param {object|null|undefined} props
   * @returns {object}
   */
  const _stripOrphanMainBundleProperties = (props) => {
    const p = props || {};
    const bt = p._bundle_type;
    if (bt === 'mix' || bt === 'pwp') {
      const out = {};
      for (const [k, v] of Object.entries(p)) {
        if (k === '_pwp_role' || k === '_gwp_role') continue;
        out[k] = v;
      }
      return out;
    }
    return _stripBundleLineProperties(props);
  };
  
  let reconcileBundleItemsInProgress = false;

  const _bundleMergeRole = (props) => {
    const p = props || {};
    if (p._bundle_role === 'main') return 'main';
    if (p._gwp_role === 'gwp_child') return 'gwp_child';
    if (p._pwp_role === 'pwp_child') return 'pwp_child';
    if (
      (p._bundle_type === 'pwp' && (p._pwp_role === 'pwp_main' || p._pwp_role == null)) ||
      (p._bundle_type === 'gwp' && (p._gwp_role === 'gwp_main' || p._gwp_role == null))
    ) {
      return 'main';
    }
    return null;
  };

  /**
   * Same SKU + same bundle role (main / GWP child / PWP child) should be one line.
   * Duplicate lines from unique `_bundle_id`s are collapsed; leftover children are
   * retargeted to the surviving main's bundle id so orphan cleanup stays correct.
   *
   * @param {Array} items
   * @returns {{ qtyUpdates: Object, propertyPatches: Array<{ item: object, properties: object }> }}
   */
  const _planDuplicateBundleSkuMerge = (items) => {
    const qtyUpdates = {};
    const propertyPatches = [];
    const bundleIdToMainVariant = {};
    for (const item of items) {
      const props = item.properties || {};
      if (_bundleMergeRole(props) !== 'main' || props._bundle_id == null || item.quantity <= 0) continue;
      bundleIdToMainVariant[String(props._bundle_id)] = String(item.variant_id);
    }

    const groups = {};
    for (const item of items) {
      if (item.quantity <= 0) continue;
      const props = item.properties || {};
      const role = _bundleMergeRole(props);
      if (!role) continue;
      const parentVariant =
        role === 'main'
          ? String(item.variant_id)
          : bundleIdToMainVariant[String(props._bundle_id)] || '';
      if (!parentVariant) continue;
      const plan = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) || '';
      const key = `${item.variant_id}::${role}::${parentVariant}::${plan}`;
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    }

    const bundleIdRemap = {};
    for (const group of Object.values(groups)) {
      if (!group.length) continue;
      const role = _bundleMergeRole(group[0].properties || {});
      if (role === 'main' && group[0].properties && group[0].properties._bundle_id != null) {
        const canonical = String(group[0].properties._bundle_id);
        for (const item of group) {
          if (item.properties && item.properties._bundle_id != null) {
            bundleIdRemap[String(item.properties._bundle_id)] = canonical;
          }
        }
      }
      if (group.length < 2) continue;
      const keeper = group[0];
      const totalQty = group.reduce((sum, line) => sum + (line.quantity || 0), 0);
      qtyUpdates[keeper.key] = totalQty;
      for (let i = 1; i < group.length; i++) {
        qtyUpdates[group[i].key] = 0;
      }
    }

    if (Object.keys(bundleIdRemap).length) {
      for (const item of items) {
        if (item.quantity <= 0 || qtyUpdates[item.key] === 0) continue;
        const props = item.properties || {};
        if (props._bundle_id == null) continue;
        const nextId = bundleIdRemap[String(props._bundle_id)];
        if (!nextId || nextId === String(props._bundle_id)) continue;
        propertyPatches.push({
          item,
          properties: Object.assign({}, props, { _bundle_id: nextId })
        });
      }
    }

    return { qtyUpdates, propertyPatches };
  };
  
  /**
   * Validates and enforces bundle relationships in the cart using _bundle_id, _bundle_role (main), or legacy _pwp_role / _gwp_role.
   * Removes orphaned children (no main or main qty 0). Orphan bundle mains (no remaining children) stay in the cart:
   * bundle line properties are cleared via cart/change.js instead of removing the line.
   *
   * @param {Object} options
   * @param {boolean} options.debug - Log inconsistencies to console
   * @returns {Promise<{ changed: boolean, removed?: number, stripped?: number }>}
   */
  const reconcileBundleItems = async (options = {}) => {
    const debug = options.debug === true;
    if (reconcileBundleItemsInProgress) {
      if (debug) console.log('[reconcileBundleItems] Skipped: already in progress');
      return { changed: false };
    }
    reconcileBundleItemsInProgress = true;
    let $loader = { length: 0 };
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const base = root.replace(/\/$/, '');
      const res = await fetch(base + '/cart.js');
      let cart = await res.json();
      const headers = {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      };
      const mergePlan = _planDuplicateBundleSkuMerge(cart.items || []);
      const mergeQtyKeys = Object.keys(mergePlan.qtyUpdates);
      let merged = false;
      if (mergeQtyKeys.length) {
        const updateUrl = base + '/cart/update.js';
        const batchRes = await fetch(updateUrl, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ updates: mergePlan.qtyUpdates }),
          credentials: 'same-origin'
        });
        if (batchRes.ok) {
          merged = true;
          cart = await batchRes.json();
        }
      }
      if (mergePlan.propertyPatches.length) {
        for (const patch of mergePlan.propertyPatches) {
          const stillInCart = (cart.items || []).some((line) => line.key === patch.item.key && line.quantity > 0);
          if (!stillInCart) continue;
          const stripRes = await fetch(base + '/cart/change.js', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
              id: patch.item.key,
              quantity: mergePlan.qtyUpdates[patch.item.key] != null ? mergePlan.qtyUpdates[patch.item.key] : patch.item.quantity,
              properties: patch.properties
            }),
            credentials: 'same-origin'
          });
          if (stripRes.ok) {
            merged = true;
            cart = await stripRes.json();
          }
        }
      }
      const items = cart.items || [];
      const byBundle = {};
      for (const item of items) {
        const props = item.properties || {};
        const bid = props._bundle_id != null ? props._bundle_id : null;
        if (bid == null) continue;
        const id = String(bid);
        if (!byBundle[id]) byBundle[id] = { main: [], child: [] };
        if (props._bundle_role === 'main') {
          byBundle[id].main.push(item);
          continue;
        }
        if (
          (props._bundle_type === 'pwp' &&
            (props._pwp_role === 'pwp_main' || props._pwp_role == null)) ||
          (props._bundle_type === 'gwp' &&
            (props._gwp_role === 'gwp_main' || props._gwp_role == null))
        ) {
          byBundle[id].main.push(item);
          continue;
        }
        if (
          (props._bundle_type === 'pwp' &&
            (props._pwp_role === 'pwp_child' || props._pwp_role == null)) ||
          (props._bundle_type === 'gwp' &&
            (props._gwp_role === 'gwp_child' || props._gwp_role == null))
        ) {
          byBundle[id].child.push(item);
        }
      }
      const orphanChildKeys = [];
      /** @type {Map<string, object>} */
      const mainsToStripByKey = new Map();
      const childQtyUpdates = {};
      const missingMain = [];
      const missingChild = [];
      for (const [bundleId, group] of Object.entries(byBundle)) {
        const mainWithQty = group.main.filter((m) => m.quantity > 0);
        const childWithQty = group.child.filter((c) => c.quantity > 0);
        const mainQty = mainWithQty.reduce((sum, m) => sum + m.quantity, 0);
        for (const c of group.child) {
          if (c.quantity === 0) continue;
          if (mainWithQty.length === 0) {
            orphanChildKeys.push(c.key);
            if (debug) missingMain.push({ bundleId, key: c.key });
            continue;
          }
          // One gift unit per main unit, but never more than the block's "Max products"
          // setting stamped on the line at add time. Synced both ways, so raising the
          // main qty tops the gifts up to the cap and lowering it (or a double-clicked
          // add) leaves no extra gift units behind.
          const childCap = parseInt((c.properties || {})._bundle_max, 10) || 0;
          const targetQty = childCap > 0 ? Math.min(mainQty, childCap) : mainQty;
          if (mainQty > 0 && c.quantity !== targetQty) {
            childQtyUpdates[c.key] = targetQty;
          }
        }
        for (const m of group.main) {
          if (m.quantity === 0) continue;
          if (childWithQty.length === 0) {
            mainsToStripByKey.set(m.key, m);
            if (debug) missingChild.push({ bundleId, key: m.key });
          }
        }
      }
      if (debug && (missingMain.length || missingChild.length)) {
        console.log('[reconcileBundleItems] Inconsistencies:', { missingMain, missingChild });
      }
      const mainsToStrip = [...mainsToStripByKey.values()];
      const childQtyKeys = Object.keys(childQtyUpdates);
      if (orphanChildKeys.length === 0 && mainsToStrip.length === 0 && childQtyKeys.length === 0) {
        if (merged) {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { cart: cart },
              bubbles: true
            })
          );
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          return { changed: true, merged: true };
        }
        return { changed: false };
      }
      $loader = typeof $ !== 'undefined' ? $('.jsc-loader-overlay') : { length: 0 };
      if ($loader.length) {
        $loader.show();
        document.body.style.overflow = 'hidden';
      }
      if (childQtyKeys.length) {
        if (debug) console.log('[reconcileBundleItems] Syncing gift qty to main:', childQtyUpdates);
        const syncRes = await fetch(base + '/cart/update.js', {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ updates: childQtyUpdates }),
          credentials: 'same-origin'
        });
        if (!syncRes.ok) {
          console.warn('[reconcileBundleItems] sync gift qty failed', syncRes.status);
        }
      }
      const uniqueOrphanChildKeys = [...new Set(orphanChildKeys)];
      if (uniqueOrphanChildKeys.length) {
        const updates = {};
        for (const key of uniqueOrphanChildKeys) {
          updates[key] = 0;
        }
        const updateUrl = base + '/cart/update.js';
        let batchRes = await fetch(updateUrl, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ updates: updates }),
          credentials: 'same-origin'
        });
        if (!batchRes.ok) {
          const changeUrl = base + '/cart/change.js';
          await Promise.all(
            uniqueOrphanChildKeys.map((key) =>
              fetch(changeUrl, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ id: key, quantity: 0 }),
                credentials: 'same-origin'
              })
            )
          );
        }
      }
      for (const mainLine of mainsToStrip) {
        const stripRes = await fetch(base + '/cart/change.js', {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            id: mainLine.key,
            quantity: mainLine.quantity,
            properties: _stripOrphanMainBundleProperties(mainLine.properties)
          }),
          credentials: 'same-origin'
        });
        if (!stripRes.ok) {
          console.warn('[reconcileBundleItems] strip bundle props failed', mainLine.key, stripRes.status);
        }
      }
      const cartRefresh = await fetch(base + '/cart.js?t=' + Date.now()).then((r) => r.json());
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: cartRefresh },
          bubbles: true
        })
      );
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      return {
        changed: true,
        removed: uniqueOrphanChildKeys.length,
        stripped: mainsToStrip.length,
        clamped: childQtyKeys.length
      };
    } catch (err) {
      console.error('[reconcileBundleItems] Error:', err);
      return { changed: false };
    } finally {
      if ($loader.length) {
        $loader.hide();
        document.body.style.overflow = '';
      }
      reconcileBundleItemsInProgress = false;
    }
  };
  
  window.reconcileBundleItems = reconcileBundleItems;
  
  /**
   * Hook into existing cart flow:
   * - On cart:updated (quantity change, item removal, etc.): reconcile orphans.
   * - Nested reconcile is skipped while in progress to avoid infinite loops.
   */
  function applyBundleReconciliationHooks() {
    document.addEventListener('cart:updated', function onCartUpdated() {
      window.reconcileBundleItems({ debug: false });
    });
  
    if (window.location.pathname.includes('/cart')) {
      setTimeout(function () {
        window.reconcileBundleItems({ debug: false });
      }, 0);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBundleReconciliationHooks);
  } else {
    applyBundleReconciliationHooks();
  }
  // end: bundle reconciliation
  // start: hulk form scroll to show error message
  (() => {
    const HULK_ORIGIN = 'https://formbuilder.hulkapps.com';
    const SCROLL_REQUEST_TYPE = 'vw:hulk-scroll-request';
    const SCROLL_HEADER_OFFSET_PX = 164;

    window.addEventListener('message', (event) => {
      if (event.origin !== HULK_ORIGIN) return;

      const data = event.data;
      if (!data || data.type !== SCROLL_REQUEST_TYPE || !data.formId) return;

      const iframe = document.getElementById(`frame_${data.formId}`);
      if (!iframe || event.source !== iframe.contentWindow) return;

      const iframeTop = iframe.getBoundingClientRect().top + window.scrollY;
      const offsetTop = Number(data.offsetTop) || 0;

      window.scrollTo({
        top: Math.max(iframeTop + offsetTop - SCROLL_HEADER_OFFSET_PX, 0),
        behavior: 'smooth'
      });
    });
  })();
  // end: hulk form scroll to show error message